/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from "./routes/__root"
import { Route as IndexImport } from "./routes/index"
import { Route as workersWorkersImport } from "./routes/(workers)/workers"
import { Route as toursToursImport } from "./routes/(tours)/tours"
import { Route as servicesServicesImport } from "./routes/(services)/services"
import { Route as regionsRegionsImport } from "./routes/(regions)/regions"
import { Route as providersProvidersImport } from "./routes/(providers)/providers"
import { Route as operationsOperationsImport } from "./routes/(operations)/operations"
import { Route as hotelsHotelsImport } from "./routes/(hotels)/hotels"
import { Route as guidesGuidesImport } from "./routes/(guides)/guides"
import { Route as departmentsDepartmentsImport } from "./routes/(departments)/departments"
import { Route as agenciesAgenciesImport } from "./routes/(agencies)/agencies"
import { Route as reservationsReservationsIndexImport } from "./routes/(reservations)/reservations.index"
import { Route as workersWorkersSheetImport } from "./routes/(workers)/workers/_sheet"
import { Route as toursToursSheetImport } from "./routes/(tours)/tours/_sheet"
import { Route as tourDaysTourDaysIdImport } from "./routes/(tour-days)/tour-days.$id"
import { Route as tourAgenciesTourAgenciesIdImport } from "./routes/(tour-agencies)/tour-agencies.$id"
import { Route as servicesServicesSheetImport } from "./routes/(services)/services/_sheet"
import { Route as serviceProvidersServiceProvidersIdImport } from "./routes/(service-providers)/service-providers.$id"
import { Route as reservationsReservationsNewImport } from "./routes/(reservations)/reservations/new"
import { Route as regionsRegionsSheetImport } from "./routes/(regions)/regions/_sheet"
import { Route as providersProvidersSheetImport } from "./routes/(providers)/providers/_sheet"
import { Route as hotelsHotelsSheetImport } from "./routes/(hotels)/hotels/_sheet"
import { Route as hotelRoomsHotelRoomsIdImport } from "./routes/(hotel-rooms)/hotel-rooms.$id"
import { Route as guidesGuidesSheetImport } from "./routes/(guides)/guides/_sheet"
import { Route as departmentsDepartmentsSheetImport } from "./routes/(departments)/departments/_sheet"
import { Route as agenciesAgenciesSheetImport } from "./routes/(agencies)/agencies/_sheet"
import { Route as reservationsReservationsCalendarIndexImport } from "./routes/(reservations)/reservations/calendar/index"
import { Route as reservationsReservationsIdIndexImport } from "./routes/(reservations)/reservations/$id.index"
import { Route as workersWorkersSheetNewImport } from "./routes/(workers)/workers/_sheet.new"
import { Route as toursToursSheetNewImport } from "./routes/(tours)/tours/_sheet.new"
import { Route as tourAgenciesTourAgenciesIdSheetImport } from "./routes/(tour-agencies)/tour-agencies.$id/_sheet"
import { Route as servicesServicesSheetNewImport } from "./routes/(services)/services/_sheet.new"
import { Route as serviceProvidersServiceProvidersIdSheetImport } from "./routes/(service-providers)/service-providers.$id/_sheet"
import { Route as reservationsReservationsIdFulfillmentsImport } from "./routes/(reservations)/reservations/$id.fulfillments"
import { Route as reservationsReservationsIdEditImport } from "./routes/(reservations)/reservations/$id.edit"
import { Route as regionsRegionsSheetNewImport } from "./routes/(regions)/regions/_sheet.new"
import { Route as providersProvidersSheetNewImport } from "./routes/(providers)/providers/_sheet.new"
import { Route as hotelsHotelsSheetNewImport } from "./routes/(hotels)/hotels/_sheet.new"
import { Route as hotelRoomsHotelRoomsIdSheetImport } from "./routes/(hotel-rooms)/hotel-rooms.$id/_sheet"
import { Route as guidesGuidesSheetNewImport } from "./routes/(guides)/guides/_sheet.new"
import { Route as departmentsDepartmentsSheetNewImport } from "./routes/(departments)/departments/_sheet.new"
import { Route as agenciesAgenciesSheetNewImport } from "./routes/(agencies)/agencies/_sheet.new"
import { Route as workersWorkersSheetIdIndexImport } from "./routes/(workers)/workers/_sheet.$id.index"
import { Route as toursToursSheetIdIndexImport } from "./routes/(tours)/tours/_sheet.$id.index"
import { Route as servicesServicesSheetIdIndexImport } from "./routes/(services)/services/_sheet.$id.index"
import { Route as reservationsReservationsCalendarNewIndexImport } from "./routes/(reservations)/reservations/calendar/new.index"
import { Route as reservationsReservationsCalendarIdIndexImport } from "./routes/(reservations)/reservations/calendar/$id.index"
import { Route as regionsRegionsSheetIdIndexImport } from "./routes/(regions)/regions/_sheet.$id.index"
import { Route as providersProvidersSheetIdIndexImport } from "./routes/(providers)/providers/_sheet.$id.index"
import { Route as hotelsHotelsSheetIdIndexImport } from "./routes/(hotels)/hotels/_sheet.$id.index"
import { Route as guidesGuidesSheetIdIndexImport } from "./routes/(guides)/guides/_sheet.$id.index"
import { Route as departmentsDepartmentsSheetIdIndexImport } from "./routes/(departments)/departments/_sheet.$id.index"
import { Route as agenciesAgenciesSheetIdIndexImport } from "./routes/(agencies)/agencies/_sheet.$id.index"
import { Route as workersWorkersSheetIdEditImport } from "./routes/(workers)/workers/_sheet.$id.edit"
import { Route as toursToursSheetIdEditImport } from "./routes/(tours)/tours/_sheet.$id.edit"
import { Route as tourAgenciesTourAgenciesIdSheetNewImport } from "./routes/(tour-agencies)/tour-agencies.$id/_sheet.new"
import { Route as servicesServicesSheetIdEditImport } from "./routes/(services)/services/_sheet.$id.edit"
import { Route as serviceProvidersServiceProvidersIdSheetNewImport } from "./routes/(service-providers)/service-providers.$id/_sheet.new"
import { Route as reservationsReservationsCalendarIdFulfillmentsImport } from "./routes/(reservations)/reservations/calendar/$id.fulfillments"
import { Route as reservationsReservationsCalendarIdEditImport } from "./routes/(reservations)/reservations/calendar/$id.edit"
import { Route as regionsRegionsSheetIdEditImport } from "./routes/(regions)/regions/_sheet.$id.edit"
import { Route as providersProvidersSheetIdEditImport } from "./routes/(providers)/providers/_sheet.$id.edit"
import { Route as hotelsHotelsSheetIdEditImport } from "./routes/(hotels)/hotels/_sheet.$id.edit"
import { Route as hotelRoomsHotelRoomsIdSheetNewImport } from "./routes/(hotel-rooms)/hotel-rooms.$id/_sheet.new"
import { Route as hotelRoomsHotelRoomsIdSheetRidImport } from "./routes/(hotel-rooms)/hotel-rooms.$id/_sheet.$rid"
import { Route as guidesGuidesSheetIdEditImport } from "./routes/(guides)/guides/_sheet.$id.edit"
import { Route as departmentsDepartmentsSheetIdEditImport } from "./routes/(departments)/departments/_sheet.$id.edit"
import { Route as agenciesAgenciesSheetIdEditImport } from "./routes/(agencies)/agencies/_sheet.$id.edit"
import { Route as tourAgenciesTourAgenciesIdSheetEditTaIdImport } from "./routes/(tour-agencies)/tour-agencies.$id/_sheet.edit.$taId"
import { Route as serviceProvidersServiceProvidersIdSheetEditSpIdImport } from "./routes/(service-providers)/service-providers.$id/_sheet.edit.$spId"

// Create/Update Routes

const IndexRoute = IndexImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRoute,
} as any)

const workersWorkersRoute = workersWorkersImport.update({
  id: "/(workers)/workers",
  path: "/workers",
  getParentRoute: () => rootRoute,
} as any)

const toursToursRoute = toursToursImport.update({
  id: "/(tours)/tours",
  path: "/tours",
  getParentRoute: () => rootRoute,
} as any)

const servicesServicesRoute = servicesServicesImport.update({
  id: "/(services)/services",
  path: "/services",
  getParentRoute: () => rootRoute,
} as any)

const regionsRegionsRoute = regionsRegionsImport.update({
  id: "/(regions)/regions",
  path: "/regions",
  getParentRoute: () => rootRoute,
} as any)

const providersProvidersRoute = providersProvidersImport.update({
  id: "/(providers)/providers",
  path: "/providers",
  getParentRoute: () => rootRoute,
} as any)

const operationsOperationsRoute = operationsOperationsImport.update({
  id: "/(operations)/operations",
  path: "/operations",
  getParentRoute: () => rootRoute,
} as any)

const hotelsHotelsRoute = hotelsHotelsImport.update({
  id: "/(hotels)/hotels",
  path: "/hotels",
  getParentRoute: () => rootRoute,
} as any)

const guidesGuidesRoute = guidesGuidesImport.update({
  id: "/(guides)/guides",
  path: "/guides",
  getParentRoute: () => rootRoute,
} as any)

const departmentsDepartmentsRoute = departmentsDepartmentsImport.update({
  id: "/(departments)/departments",
  path: "/departments",
  getParentRoute: () => rootRoute,
} as any)

const agenciesAgenciesRoute = agenciesAgenciesImport.update({
  id: "/(agencies)/agencies",
  path: "/agencies",
  getParentRoute: () => rootRoute,
} as any)

const reservationsReservationsIndexRoute =
  reservationsReservationsIndexImport.update({
    id: "/(reservations)/reservations/",
    path: "/reservations/",
    getParentRoute: () => rootRoute,
  } as any)

const workersWorkersSheetRoute = workersWorkersSheetImport.update({
  id: "/_sheet",
  getParentRoute: () => workersWorkersRoute,
} as any)

const toursToursSheetRoute = toursToursSheetImport.update({
  id: "/_sheet",
  getParentRoute: () => toursToursRoute,
} as any)

const tourDaysTourDaysIdRoute = tourDaysTourDaysIdImport.update({
  id: "/(tour-days)/tour-days/$id",
  path: "/tour-days/$id",
  getParentRoute: () => rootRoute,
} as any)

const tourAgenciesTourAgenciesIdRoute = tourAgenciesTourAgenciesIdImport.update(
  {
    id: "/(tour-agencies)/tour-agencies/$id",
    path: "/tour-agencies/$id",
    getParentRoute: () => rootRoute,
  } as any,
)

const servicesServicesSheetRoute = servicesServicesSheetImport.update({
  id: "/_sheet",
  getParentRoute: () => servicesServicesRoute,
} as any)

const serviceProvidersServiceProvidersIdRoute =
  serviceProvidersServiceProvidersIdImport.update({
    id: "/(service-providers)/service-providers/$id",
    path: "/service-providers/$id",
    getParentRoute: () => rootRoute,
  } as any)

const reservationsReservationsNewRoute =
  reservationsReservationsNewImport.update({
    id: "/(reservations)/reservations/new",
    path: "/reservations/new",
    getParentRoute: () => rootRoute,
  } as any)

const regionsRegionsSheetRoute = regionsRegionsSheetImport.update({
  id: "/_sheet",
  getParentRoute: () => regionsRegionsRoute,
} as any)

const providersProvidersSheetRoute = providersProvidersSheetImport.update({
  id: "/_sheet",
  getParentRoute: () => providersProvidersRoute,
} as any)

const hotelsHotelsSheetRoute = hotelsHotelsSheetImport.update({
  id: "/_sheet",
  getParentRoute: () => hotelsHotelsRoute,
} as any)

const hotelRoomsHotelRoomsIdRoute = hotelRoomsHotelRoomsIdImport.update({
  id: "/(hotel-rooms)/hotel-rooms/$id",
  path: "/hotel-rooms/$id",
  getParentRoute: () => rootRoute,
} as any)

const guidesGuidesSheetRoute = guidesGuidesSheetImport.update({
  id: "/_sheet",
  getParentRoute: () => guidesGuidesRoute,
} as any)

const departmentsDepartmentsSheetRoute =
  departmentsDepartmentsSheetImport.update({
    id: "/_sheet",
    getParentRoute: () => departmentsDepartmentsRoute,
  } as any)

const agenciesAgenciesSheetRoute = agenciesAgenciesSheetImport.update({
  id: "/_sheet",
  getParentRoute: () => agenciesAgenciesRoute,
} as any)

const reservationsReservationsCalendarIndexRoute =
  reservationsReservationsCalendarIndexImport.update({
    id: "/(reservations)/reservations/calendar/",
    path: "/reservations/calendar/",
    getParentRoute: () => rootRoute,
  } as any)

const reservationsReservationsIdIndexRoute =
  reservationsReservationsIdIndexImport.update({
    id: "/(reservations)/reservations/$id/",
    path: "/reservations/$id/",
    getParentRoute: () => rootRoute,
  } as any)

const workersWorkersSheetNewRoute = workersWorkersSheetNewImport.update({
  id: "/new",
  path: "/new",
  getParentRoute: () => workersWorkersSheetRoute,
} as any)

const toursToursSheetNewRoute = toursToursSheetNewImport.update({
  id: "/new",
  path: "/new",
  getParentRoute: () => toursToursSheetRoute,
} as any)

const tourAgenciesTourAgenciesIdSheetRoute =
  tourAgenciesTourAgenciesIdSheetImport.update({
    id: "/_sheet",
    getParentRoute: () => tourAgenciesTourAgenciesIdRoute,
  } as any)

const servicesServicesSheetNewRoute = servicesServicesSheetNewImport.update({
  id: "/new",
  path: "/new",
  getParentRoute: () => servicesServicesSheetRoute,
} as any)

const serviceProvidersServiceProvidersIdSheetRoute =
  serviceProvidersServiceProvidersIdSheetImport.update({
    id: "/_sheet",
    getParentRoute: () => serviceProvidersServiceProvidersIdRoute,
  } as any)

const reservationsReservationsIdFulfillmentsRoute =
  reservationsReservationsIdFulfillmentsImport.update({
    id: "/(reservations)/reservations/$id/fulfillments",
    path: "/reservations/$id/fulfillments",
    getParentRoute: () => rootRoute,
  } as any)

const reservationsReservationsIdEditRoute =
  reservationsReservationsIdEditImport.update({
    id: "/(reservations)/reservations/$id/edit",
    path: "/reservations/$id/edit",
    getParentRoute: () => rootRoute,
  } as any)

const regionsRegionsSheetNewRoute = regionsRegionsSheetNewImport.update({
  id: "/new",
  path: "/new",
  getParentRoute: () => regionsRegionsSheetRoute,
} as any)

const providersProvidersSheetNewRoute = providersProvidersSheetNewImport.update(
  {
    id: "/new",
    path: "/new",
    getParentRoute: () => providersProvidersSheetRoute,
  } as any,
)

const hotelsHotelsSheetNewRoute = hotelsHotelsSheetNewImport.update({
  id: "/new",
  path: "/new",
  getParentRoute: () => hotelsHotelsSheetRoute,
} as any)

const hotelRoomsHotelRoomsIdSheetRoute =
  hotelRoomsHotelRoomsIdSheetImport.update({
    id: "/_sheet",
    getParentRoute: () => hotelRoomsHotelRoomsIdRoute,
  } as any)

const guidesGuidesSheetNewRoute = guidesGuidesSheetNewImport.update({
  id: "/new",
  path: "/new",
  getParentRoute: () => guidesGuidesSheetRoute,
} as any)

const departmentsDepartmentsSheetNewRoute =
  departmentsDepartmentsSheetNewImport.update({
    id: "/new",
    path: "/new",
    getParentRoute: () => departmentsDepartmentsSheetRoute,
  } as any)

const agenciesAgenciesSheetNewRoute = agenciesAgenciesSheetNewImport.update({
  id: "/new",
  path: "/new",
  getParentRoute: () => agenciesAgenciesSheetRoute,
} as any)

const workersWorkersSheetIdIndexRoute = workersWorkersSheetIdIndexImport.update(
  {
    id: "/$id/",
    path: "/$id/",
    getParentRoute: () => workersWorkersSheetRoute,
  } as any,
)

const toursToursSheetIdIndexRoute = toursToursSheetIdIndexImport.update({
  id: "/$id/",
  path: "/$id/",
  getParentRoute: () => toursToursSheetRoute,
} as any)

const servicesServicesSheetIdIndexRoute =
  servicesServicesSheetIdIndexImport.update({
    id: "/$id/",
    path: "/$id/",
    getParentRoute: () => servicesServicesSheetRoute,
  } as any)

const reservationsReservationsCalendarNewIndexRoute =
  reservationsReservationsCalendarNewIndexImport.update({
    id: "/(reservations)/reservations/calendar/new/",
    path: "/reservations/calendar/new/",
    getParentRoute: () => rootRoute,
  } as any)

const reservationsReservationsCalendarIdIndexRoute =
  reservationsReservationsCalendarIdIndexImport.update({
    id: "/(reservations)/reservations/calendar/$id/",
    path: "/reservations/calendar/$id/",
    getParentRoute: () => rootRoute,
  } as any)

const regionsRegionsSheetIdIndexRoute = regionsRegionsSheetIdIndexImport.update(
  {
    id: "/$id/",
    path: "/$id/",
    getParentRoute: () => regionsRegionsSheetRoute,
  } as any,
)

const providersProvidersSheetIdIndexRoute =
  providersProvidersSheetIdIndexImport.update({
    id: "/$id/",
    path: "/$id/",
    getParentRoute: () => providersProvidersSheetRoute,
  } as any)

const hotelsHotelsSheetIdIndexRoute = hotelsHotelsSheetIdIndexImport.update({
  id: "/$id/",
  path: "/$id/",
  getParentRoute: () => hotelsHotelsSheetRoute,
} as any)

const guidesGuidesSheetIdIndexRoute = guidesGuidesSheetIdIndexImport.update({
  id: "/$id/",
  path: "/$id/",
  getParentRoute: () => guidesGuidesSheetRoute,
} as any)

const departmentsDepartmentsSheetIdIndexRoute =
  departmentsDepartmentsSheetIdIndexImport.update({
    id: "/$id/",
    path: "/$id/",
    getParentRoute: () => departmentsDepartmentsSheetRoute,
  } as any)

const agenciesAgenciesSheetIdIndexRoute =
  agenciesAgenciesSheetIdIndexImport.update({
    id: "/$id/",
    path: "/$id/",
    getParentRoute: () => agenciesAgenciesSheetRoute,
  } as any)

const workersWorkersSheetIdEditRoute = workersWorkersSheetIdEditImport.update({
  id: "/$id/edit",
  path: "/$id/edit",
  getParentRoute: () => workersWorkersSheetRoute,
} as any)

const toursToursSheetIdEditRoute = toursToursSheetIdEditImport.update({
  id: "/$id/edit",
  path: "/$id/edit",
  getParentRoute: () => toursToursSheetRoute,
} as any)

const tourAgenciesTourAgenciesIdSheetNewRoute =
  tourAgenciesTourAgenciesIdSheetNewImport.update({
    id: "/new",
    path: "/new",
    getParentRoute: () => tourAgenciesTourAgenciesIdSheetRoute,
  } as any)

const servicesServicesSheetIdEditRoute =
  servicesServicesSheetIdEditImport.update({
    id: "/$id/edit",
    path: "/$id/edit",
    getParentRoute: () => servicesServicesSheetRoute,
  } as any)

const serviceProvidersServiceProvidersIdSheetNewRoute =
  serviceProvidersServiceProvidersIdSheetNewImport.update({
    id: "/new",
    path: "/new",
    getParentRoute: () => serviceProvidersServiceProvidersIdSheetRoute,
  } as any)

const reservationsReservationsCalendarIdFulfillmentsRoute =
  reservationsReservationsCalendarIdFulfillmentsImport.update({
    id: "/(reservations)/reservations/calendar/$id/fulfillments",
    path: "/reservations/calendar/$id/fulfillments",
    getParentRoute: () => rootRoute,
  } as any)

const reservationsReservationsCalendarIdEditRoute =
  reservationsReservationsCalendarIdEditImport.update({
    id: "/(reservations)/reservations/calendar/$id/edit",
    path: "/reservations/calendar/$id/edit",
    getParentRoute: () => rootRoute,
  } as any)

const regionsRegionsSheetIdEditRoute = regionsRegionsSheetIdEditImport.update({
  id: "/$id/edit",
  path: "/$id/edit",
  getParentRoute: () => regionsRegionsSheetRoute,
} as any)

const providersProvidersSheetIdEditRoute =
  providersProvidersSheetIdEditImport.update({
    id: "/$id/edit",
    path: "/$id/edit",
    getParentRoute: () => providersProvidersSheetRoute,
  } as any)

const hotelsHotelsSheetIdEditRoute = hotelsHotelsSheetIdEditImport.update({
  id: "/$id/edit",
  path: "/$id/edit",
  getParentRoute: () => hotelsHotelsSheetRoute,
} as any)

const hotelRoomsHotelRoomsIdSheetNewRoute =
  hotelRoomsHotelRoomsIdSheetNewImport.update({
    id: "/new",
    path: "/new",
    getParentRoute: () => hotelRoomsHotelRoomsIdSheetRoute,
  } as any)

const hotelRoomsHotelRoomsIdSheetRidRoute =
  hotelRoomsHotelRoomsIdSheetRidImport.update({
    id: "/$rid",
    path: "/$rid",
    getParentRoute: () => hotelRoomsHotelRoomsIdSheetRoute,
  } as any)

const guidesGuidesSheetIdEditRoute = guidesGuidesSheetIdEditImport.update({
  id: "/$id/edit",
  path: "/$id/edit",
  getParentRoute: () => guidesGuidesSheetRoute,
} as any)

const departmentsDepartmentsSheetIdEditRoute =
  departmentsDepartmentsSheetIdEditImport.update({
    id: "/$id/edit",
    path: "/$id/edit",
    getParentRoute: () => departmentsDepartmentsSheetRoute,
  } as any)

const agenciesAgenciesSheetIdEditRoute =
  agenciesAgenciesSheetIdEditImport.update({
    id: "/$id/edit",
    path: "/$id/edit",
    getParentRoute: () => agenciesAgenciesSheetRoute,
  } as any)

const tourAgenciesTourAgenciesIdSheetEditTaIdRoute =
  tourAgenciesTourAgenciesIdSheetEditTaIdImport.update({
    id: "/edit/$taId",
    path: "/edit/$taId",
    getParentRoute: () => tourAgenciesTourAgenciesIdSheetRoute,
  } as any)

const serviceProvidersServiceProvidersIdSheetEditSpIdRoute =
  serviceProvidersServiceProvidersIdSheetEditSpIdImport.update({
    id: "/edit/$spId",
    path: "/edit/$spId",
    getParentRoute: () => serviceProvidersServiceProvidersIdSheetRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/": {
      id: "/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    "/(agencies)/agencies": {
      id: "/(agencies)/agencies"
      path: "/agencies"
      fullPath: "/agencies"
      preLoaderRoute: typeof agenciesAgenciesImport
      parentRoute: typeof rootRoute
    }
    "/(departments)/departments": {
      id: "/(departments)/departments"
      path: "/departments"
      fullPath: "/departments"
      preLoaderRoute: typeof departmentsDepartmentsImport
      parentRoute: typeof rootRoute
    }
    "/(guides)/guides": {
      id: "/(guides)/guides"
      path: "/guides"
      fullPath: "/guides"
      preLoaderRoute: typeof guidesGuidesImport
      parentRoute: typeof rootRoute
    }
    "/(hotels)/hotels": {
      id: "/(hotels)/hotels"
      path: "/hotels"
      fullPath: "/hotels"
      preLoaderRoute: typeof hotelsHotelsImport
      parentRoute: typeof rootRoute
    }
    "/(operations)/operations": {
      id: "/(operations)/operations"
      path: "/operations"
      fullPath: "/operations"
      preLoaderRoute: typeof operationsOperationsImport
      parentRoute: typeof rootRoute
    }
    "/(providers)/providers": {
      id: "/(providers)/providers"
      path: "/providers"
      fullPath: "/providers"
      preLoaderRoute: typeof providersProvidersImport
      parentRoute: typeof rootRoute
    }
    "/(regions)/regions": {
      id: "/(regions)/regions"
      path: "/regions"
      fullPath: "/regions"
      preLoaderRoute: typeof regionsRegionsImport
      parentRoute: typeof rootRoute
    }
    "/(services)/services": {
      id: "/(services)/services"
      path: "/services"
      fullPath: "/services"
      preLoaderRoute: typeof servicesServicesImport
      parentRoute: typeof rootRoute
    }
    "/(tours)/tours": {
      id: "/(tours)/tours"
      path: "/tours"
      fullPath: "/tours"
      preLoaderRoute: typeof toursToursImport
      parentRoute: typeof rootRoute
    }
    "/(workers)/workers": {
      id: "/(workers)/workers"
      path: "/workers"
      fullPath: "/workers"
      preLoaderRoute: typeof workersWorkersImport
      parentRoute: typeof rootRoute
    }
    "/(agencies)/agencies/_sheet": {
      id: "/(agencies)/agencies/_sheet"
      path: ""
      fullPath: "/agencies"
      preLoaderRoute: typeof agenciesAgenciesSheetImport
      parentRoute: typeof agenciesAgenciesImport
    }
    "/(departments)/departments/_sheet": {
      id: "/(departments)/departments/_sheet"
      path: ""
      fullPath: "/departments"
      preLoaderRoute: typeof departmentsDepartmentsSheetImport
      parentRoute: typeof departmentsDepartmentsImport
    }
    "/(guides)/guides/_sheet": {
      id: "/(guides)/guides/_sheet"
      path: ""
      fullPath: "/guides"
      preLoaderRoute: typeof guidesGuidesSheetImport
      parentRoute: typeof guidesGuidesImport
    }
    "/(hotel-rooms)/hotel-rooms/$id": {
      id: "/(hotel-rooms)/hotel-rooms/$id"
      path: "/hotel-rooms/$id"
      fullPath: "/hotel-rooms/$id"
      preLoaderRoute: typeof hotelRoomsHotelRoomsIdImport
      parentRoute: typeof rootRoute
    }
    "/(hotels)/hotels/_sheet": {
      id: "/(hotels)/hotels/_sheet"
      path: ""
      fullPath: "/hotels"
      preLoaderRoute: typeof hotelsHotelsSheetImport
      parentRoute: typeof hotelsHotelsImport
    }
    "/(providers)/providers/_sheet": {
      id: "/(providers)/providers/_sheet"
      path: ""
      fullPath: "/providers"
      preLoaderRoute: typeof providersProvidersSheetImport
      parentRoute: typeof providersProvidersImport
    }
    "/(regions)/regions/_sheet": {
      id: "/(regions)/regions/_sheet"
      path: ""
      fullPath: "/regions"
      preLoaderRoute: typeof regionsRegionsSheetImport
      parentRoute: typeof regionsRegionsImport
    }
    "/(reservations)/reservations/new": {
      id: "/(reservations)/reservations/new"
      path: "/reservations/new"
      fullPath: "/reservations/new"
      preLoaderRoute: typeof reservationsReservationsNewImport
      parentRoute: typeof rootRoute
    }
    "/(service-providers)/service-providers/$id": {
      id: "/(service-providers)/service-providers/$id"
      path: "/service-providers/$id"
      fullPath: "/service-providers/$id"
      preLoaderRoute: typeof serviceProvidersServiceProvidersIdImport
      parentRoute: typeof rootRoute
    }
    "/(services)/services/_sheet": {
      id: "/(services)/services/_sheet"
      path: ""
      fullPath: "/services"
      preLoaderRoute: typeof servicesServicesSheetImport
      parentRoute: typeof servicesServicesImport
    }
    "/(tour-agencies)/tour-agencies/$id": {
      id: "/(tour-agencies)/tour-agencies/$id"
      path: "/tour-agencies/$id"
      fullPath: "/tour-agencies/$id"
      preLoaderRoute: typeof tourAgenciesTourAgenciesIdImport
      parentRoute: typeof rootRoute
    }
    "/(tour-days)/tour-days/$id": {
      id: "/(tour-days)/tour-days/$id"
      path: "/tour-days/$id"
      fullPath: "/tour-days/$id"
      preLoaderRoute: typeof tourDaysTourDaysIdImport
      parentRoute: typeof rootRoute
    }
    "/(tours)/tours/_sheet": {
      id: "/(tours)/tours/_sheet"
      path: ""
      fullPath: "/tours"
      preLoaderRoute: typeof toursToursSheetImport
      parentRoute: typeof toursToursImport
    }
    "/(workers)/workers/_sheet": {
      id: "/(workers)/workers/_sheet"
      path: ""
      fullPath: "/workers"
      preLoaderRoute: typeof workersWorkersSheetImport
      parentRoute: typeof workersWorkersImport
    }
    "/(reservations)/reservations/": {
      id: "/(reservations)/reservations/"
      path: "/reservations"
      fullPath: "/reservations"
      preLoaderRoute: typeof reservationsReservationsIndexImport
      parentRoute: typeof rootRoute
    }
    "/(agencies)/agencies/_sheet/new": {
      id: "/(agencies)/agencies/_sheet/new"
      path: "/new"
      fullPath: "/agencies/new"
      preLoaderRoute: typeof agenciesAgenciesSheetNewImport
      parentRoute: typeof agenciesAgenciesSheetImport
    }
    "/(departments)/departments/_sheet/new": {
      id: "/(departments)/departments/_sheet/new"
      path: "/new"
      fullPath: "/departments/new"
      preLoaderRoute: typeof departmentsDepartmentsSheetNewImport
      parentRoute: typeof departmentsDepartmentsSheetImport
    }
    "/(guides)/guides/_sheet/new": {
      id: "/(guides)/guides/_sheet/new"
      path: "/new"
      fullPath: "/guides/new"
      preLoaderRoute: typeof guidesGuidesSheetNewImport
      parentRoute: typeof guidesGuidesSheetImport
    }
    "/(hotel-rooms)/hotel-rooms/$id/_sheet": {
      id: "/(hotel-rooms)/hotel-rooms/$id/_sheet"
      path: ""
      fullPath: "/hotel-rooms/$id"
      preLoaderRoute: typeof hotelRoomsHotelRoomsIdSheetImport
      parentRoute: typeof hotelRoomsHotelRoomsIdImport
    }
    "/(hotels)/hotels/_sheet/new": {
      id: "/(hotels)/hotels/_sheet/new"
      path: "/new"
      fullPath: "/hotels/new"
      preLoaderRoute: typeof hotelsHotelsSheetNewImport
      parentRoute: typeof hotelsHotelsSheetImport
    }
    "/(providers)/providers/_sheet/new": {
      id: "/(providers)/providers/_sheet/new"
      path: "/new"
      fullPath: "/providers/new"
      preLoaderRoute: typeof providersProvidersSheetNewImport
      parentRoute: typeof providersProvidersSheetImport
    }
    "/(regions)/regions/_sheet/new": {
      id: "/(regions)/regions/_sheet/new"
      path: "/new"
      fullPath: "/regions/new"
      preLoaderRoute: typeof regionsRegionsSheetNewImport
      parentRoute: typeof regionsRegionsSheetImport
    }
    "/(reservations)/reservations/$id/edit": {
      id: "/(reservations)/reservations/$id/edit"
      path: "/reservations/$id/edit"
      fullPath: "/reservations/$id/edit"
      preLoaderRoute: typeof reservationsReservationsIdEditImport
      parentRoute: typeof rootRoute
    }
    "/(reservations)/reservations/$id/fulfillments": {
      id: "/(reservations)/reservations/$id/fulfillments"
      path: "/reservations/$id/fulfillments"
      fullPath: "/reservations/$id/fulfillments"
      preLoaderRoute: typeof reservationsReservationsIdFulfillmentsImport
      parentRoute: typeof rootRoute
    }
    "/(service-providers)/service-providers/$id/_sheet": {
      id: "/(service-providers)/service-providers/$id/_sheet"
      path: ""
      fullPath: "/service-providers/$id"
      preLoaderRoute: typeof serviceProvidersServiceProvidersIdSheetImport
      parentRoute: typeof serviceProvidersServiceProvidersIdImport
    }
    "/(services)/services/_sheet/new": {
      id: "/(services)/services/_sheet/new"
      path: "/new"
      fullPath: "/services/new"
      preLoaderRoute: typeof servicesServicesSheetNewImport
      parentRoute: typeof servicesServicesSheetImport
    }
    "/(tour-agencies)/tour-agencies/$id/_sheet": {
      id: "/(tour-agencies)/tour-agencies/$id/_sheet"
      path: ""
      fullPath: "/tour-agencies/$id"
      preLoaderRoute: typeof tourAgenciesTourAgenciesIdSheetImport
      parentRoute: typeof tourAgenciesTourAgenciesIdImport
    }
    "/(tours)/tours/_sheet/new": {
      id: "/(tours)/tours/_sheet/new"
      path: "/new"
      fullPath: "/tours/new"
      preLoaderRoute: typeof toursToursSheetNewImport
      parentRoute: typeof toursToursSheetImport
    }
    "/(workers)/workers/_sheet/new": {
      id: "/(workers)/workers/_sheet/new"
      path: "/new"
      fullPath: "/workers/new"
      preLoaderRoute: typeof workersWorkersSheetNewImport
      parentRoute: typeof workersWorkersSheetImport
    }
    "/(reservations)/reservations/$id/": {
      id: "/(reservations)/reservations/$id/"
      path: "/reservations/$id"
      fullPath: "/reservations/$id"
      preLoaderRoute: typeof reservationsReservationsIdIndexImport
      parentRoute: typeof rootRoute
    }
    "/(reservations)/reservations/calendar/": {
      id: "/(reservations)/reservations/calendar/"
      path: "/reservations/calendar"
      fullPath: "/reservations/calendar"
      preLoaderRoute: typeof reservationsReservationsCalendarIndexImport
      parentRoute: typeof rootRoute
    }
    "/(agencies)/agencies/_sheet/$id/edit": {
      id: "/(agencies)/agencies/_sheet/$id/edit"
      path: "/$id/edit"
      fullPath: "/agencies/$id/edit"
      preLoaderRoute: typeof agenciesAgenciesSheetIdEditImport
      parentRoute: typeof agenciesAgenciesSheetImport
    }
    "/(departments)/departments/_sheet/$id/edit": {
      id: "/(departments)/departments/_sheet/$id/edit"
      path: "/$id/edit"
      fullPath: "/departments/$id/edit"
      preLoaderRoute: typeof departmentsDepartmentsSheetIdEditImport
      parentRoute: typeof departmentsDepartmentsSheetImport
    }
    "/(guides)/guides/_sheet/$id/edit": {
      id: "/(guides)/guides/_sheet/$id/edit"
      path: "/$id/edit"
      fullPath: "/guides/$id/edit"
      preLoaderRoute: typeof guidesGuidesSheetIdEditImport
      parentRoute: typeof guidesGuidesSheetImport
    }
    "/(hotel-rooms)/hotel-rooms/$id/_sheet/$rid": {
      id: "/(hotel-rooms)/hotel-rooms/$id/_sheet/$rid"
      path: "/$rid"
      fullPath: "/hotel-rooms/$id/$rid"
      preLoaderRoute: typeof hotelRoomsHotelRoomsIdSheetRidImport
      parentRoute: typeof hotelRoomsHotelRoomsIdSheetImport
    }
    "/(hotel-rooms)/hotel-rooms/$id/_sheet/new": {
      id: "/(hotel-rooms)/hotel-rooms/$id/_sheet/new"
      path: "/new"
      fullPath: "/hotel-rooms/$id/new"
      preLoaderRoute: typeof hotelRoomsHotelRoomsIdSheetNewImport
      parentRoute: typeof hotelRoomsHotelRoomsIdSheetImport
    }
    "/(hotels)/hotels/_sheet/$id/edit": {
      id: "/(hotels)/hotels/_sheet/$id/edit"
      path: "/$id/edit"
      fullPath: "/hotels/$id/edit"
      preLoaderRoute: typeof hotelsHotelsSheetIdEditImport
      parentRoute: typeof hotelsHotelsSheetImport
    }
    "/(providers)/providers/_sheet/$id/edit": {
      id: "/(providers)/providers/_sheet/$id/edit"
      path: "/$id/edit"
      fullPath: "/providers/$id/edit"
      preLoaderRoute: typeof providersProvidersSheetIdEditImport
      parentRoute: typeof providersProvidersSheetImport
    }
    "/(regions)/regions/_sheet/$id/edit": {
      id: "/(regions)/regions/_sheet/$id/edit"
      path: "/$id/edit"
      fullPath: "/regions/$id/edit"
      preLoaderRoute: typeof regionsRegionsSheetIdEditImport
      parentRoute: typeof regionsRegionsSheetImport
    }
    "/(reservations)/reservations/calendar/$id/edit": {
      id: "/(reservations)/reservations/calendar/$id/edit"
      path: "/reservations/calendar/$id/edit"
      fullPath: "/reservations/calendar/$id/edit"
      preLoaderRoute: typeof reservationsReservationsCalendarIdEditImport
      parentRoute: typeof rootRoute
    }
    "/(reservations)/reservations/calendar/$id/fulfillments": {
      id: "/(reservations)/reservations/calendar/$id/fulfillments"
      path: "/reservations/calendar/$id/fulfillments"
      fullPath: "/reservations/calendar/$id/fulfillments"
      preLoaderRoute: typeof reservationsReservationsCalendarIdFulfillmentsImport
      parentRoute: typeof rootRoute
    }
    "/(service-providers)/service-providers/$id/_sheet/new": {
      id: "/(service-providers)/service-providers/$id/_sheet/new"
      path: "/new"
      fullPath: "/service-providers/$id/new"
      preLoaderRoute: typeof serviceProvidersServiceProvidersIdSheetNewImport
      parentRoute: typeof serviceProvidersServiceProvidersIdSheetImport
    }
    "/(services)/services/_sheet/$id/edit": {
      id: "/(services)/services/_sheet/$id/edit"
      path: "/$id/edit"
      fullPath: "/services/$id/edit"
      preLoaderRoute: typeof servicesServicesSheetIdEditImport
      parentRoute: typeof servicesServicesSheetImport
    }
    "/(tour-agencies)/tour-agencies/$id/_sheet/new": {
      id: "/(tour-agencies)/tour-agencies/$id/_sheet/new"
      path: "/new"
      fullPath: "/tour-agencies/$id/new"
      preLoaderRoute: typeof tourAgenciesTourAgenciesIdSheetNewImport
      parentRoute: typeof tourAgenciesTourAgenciesIdSheetImport
    }
    "/(tours)/tours/_sheet/$id/edit": {
      id: "/(tours)/tours/_sheet/$id/edit"
      path: "/$id/edit"
      fullPath: "/tours/$id/edit"
      preLoaderRoute: typeof toursToursSheetIdEditImport
      parentRoute: typeof toursToursSheetImport
    }
    "/(workers)/workers/_sheet/$id/edit": {
      id: "/(workers)/workers/_sheet/$id/edit"
      path: "/$id/edit"
      fullPath: "/workers/$id/edit"
      preLoaderRoute: typeof workersWorkersSheetIdEditImport
      parentRoute: typeof workersWorkersSheetImport
    }
    "/(agencies)/agencies/_sheet/$id/": {
      id: "/(agencies)/agencies/_sheet/$id/"
      path: "/$id"
      fullPath: "/agencies/$id"
      preLoaderRoute: typeof agenciesAgenciesSheetIdIndexImport
      parentRoute: typeof agenciesAgenciesSheetImport
    }
    "/(departments)/departments/_sheet/$id/": {
      id: "/(departments)/departments/_sheet/$id/"
      path: "/$id"
      fullPath: "/departments/$id"
      preLoaderRoute: typeof departmentsDepartmentsSheetIdIndexImport
      parentRoute: typeof departmentsDepartmentsSheetImport
    }
    "/(guides)/guides/_sheet/$id/": {
      id: "/(guides)/guides/_sheet/$id/"
      path: "/$id"
      fullPath: "/guides/$id"
      preLoaderRoute: typeof guidesGuidesSheetIdIndexImport
      parentRoute: typeof guidesGuidesSheetImport
    }
    "/(hotels)/hotels/_sheet/$id/": {
      id: "/(hotels)/hotels/_sheet/$id/"
      path: "/$id"
      fullPath: "/hotels/$id"
      preLoaderRoute: typeof hotelsHotelsSheetIdIndexImport
      parentRoute: typeof hotelsHotelsSheetImport
    }
    "/(providers)/providers/_sheet/$id/": {
      id: "/(providers)/providers/_sheet/$id/"
      path: "/$id"
      fullPath: "/providers/$id"
      preLoaderRoute: typeof providersProvidersSheetIdIndexImport
      parentRoute: typeof providersProvidersSheetImport
    }
    "/(regions)/regions/_sheet/$id/": {
      id: "/(regions)/regions/_sheet/$id/"
      path: "/$id"
      fullPath: "/regions/$id"
      preLoaderRoute: typeof regionsRegionsSheetIdIndexImport
      parentRoute: typeof regionsRegionsSheetImport
    }
    "/(reservations)/reservations/calendar/$id/": {
      id: "/(reservations)/reservations/calendar/$id/"
      path: "/reservations/calendar/$id"
      fullPath: "/reservations/calendar/$id"
      preLoaderRoute: typeof reservationsReservationsCalendarIdIndexImport
      parentRoute: typeof rootRoute
    }
    "/(reservations)/reservations/calendar/new/": {
      id: "/(reservations)/reservations/calendar/new/"
      path: "/reservations/calendar/new"
      fullPath: "/reservations/calendar/new"
      preLoaderRoute: typeof reservationsReservationsCalendarNewIndexImport
      parentRoute: typeof rootRoute
    }
    "/(services)/services/_sheet/$id/": {
      id: "/(services)/services/_sheet/$id/"
      path: "/$id"
      fullPath: "/services/$id"
      preLoaderRoute: typeof servicesServicesSheetIdIndexImport
      parentRoute: typeof servicesServicesSheetImport
    }
    "/(tours)/tours/_sheet/$id/": {
      id: "/(tours)/tours/_sheet/$id/"
      path: "/$id"
      fullPath: "/tours/$id"
      preLoaderRoute: typeof toursToursSheetIdIndexImport
      parentRoute: typeof toursToursSheetImport
    }
    "/(workers)/workers/_sheet/$id/": {
      id: "/(workers)/workers/_sheet/$id/"
      path: "/$id"
      fullPath: "/workers/$id"
      preLoaderRoute: typeof workersWorkersSheetIdIndexImport
      parentRoute: typeof workersWorkersSheetImport
    }
    "/(service-providers)/service-providers/$id/_sheet/edit/$spId": {
      id: "/(service-providers)/service-providers/$id/_sheet/edit/$spId"
      path: "/edit/$spId"
      fullPath: "/service-providers/$id/edit/$spId"
      preLoaderRoute: typeof serviceProvidersServiceProvidersIdSheetEditSpIdImport
      parentRoute: typeof serviceProvidersServiceProvidersIdSheetImport
    }
    "/(tour-agencies)/tour-agencies/$id/_sheet/edit/$taId": {
      id: "/(tour-agencies)/tour-agencies/$id/_sheet/edit/$taId"
      path: "/edit/$taId"
      fullPath: "/tour-agencies/$id/edit/$taId"
      preLoaderRoute: typeof tourAgenciesTourAgenciesIdSheetEditTaIdImport
      parentRoute: typeof tourAgenciesTourAgenciesIdSheetImport
    }
  }
}

// Create and export the route tree

interface agenciesAgenciesSheetRouteChildren {
  agenciesAgenciesSheetNewRoute: typeof agenciesAgenciesSheetNewRoute
  agenciesAgenciesSheetIdEditRoute: typeof agenciesAgenciesSheetIdEditRoute
  agenciesAgenciesSheetIdIndexRoute: typeof agenciesAgenciesSheetIdIndexRoute
}

const agenciesAgenciesSheetRouteChildren: agenciesAgenciesSheetRouteChildren = {
  agenciesAgenciesSheetNewRoute: agenciesAgenciesSheetNewRoute,
  agenciesAgenciesSheetIdEditRoute: agenciesAgenciesSheetIdEditRoute,
  agenciesAgenciesSheetIdIndexRoute: agenciesAgenciesSheetIdIndexRoute,
}

const agenciesAgenciesSheetRouteWithChildren =
  agenciesAgenciesSheetRoute._addFileChildren(
    agenciesAgenciesSheetRouteChildren,
  )

interface agenciesAgenciesRouteChildren {
  agenciesAgenciesSheetRoute: typeof agenciesAgenciesSheetRouteWithChildren
}

const agenciesAgenciesRouteChildren: agenciesAgenciesRouteChildren = {
  agenciesAgenciesSheetRoute: agenciesAgenciesSheetRouteWithChildren,
}

const agenciesAgenciesRouteWithChildren =
  agenciesAgenciesRoute._addFileChildren(agenciesAgenciesRouteChildren)

interface departmentsDepartmentsSheetRouteChildren {
  departmentsDepartmentsSheetNewRoute: typeof departmentsDepartmentsSheetNewRoute
  departmentsDepartmentsSheetIdEditRoute: typeof departmentsDepartmentsSheetIdEditRoute
  departmentsDepartmentsSheetIdIndexRoute: typeof departmentsDepartmentsSheetIdIndexRoute
}

const departmentsDepartmentsSheetRouteChildren: departmentsDepartmentsSheetRouteChildren =
  {
    departmentsDepartmentsSheetNewRoute: departmentsDepartmentsSheetNewRoute,
    departmentsDepartmentsSheetIdEditRoute:
      departmentsDepartmentsSheetIdEditRoute,
    departmentsDepartmentsSheetIdIndexRoute:
      departmentsDepartmentsSheetIdIndexRoute,
  }

const departmentsDepartmentsSheetRouteWithChildren =
  departmentsDepartmentsSheetRoute._addFileChildren(
    departmentsDepartmentsSheetRouteChildren,
  )

interface departmentsDepartmentsRouteChildren {
  departmentsDepartmentsSheetRoute: typeof departmentsDepartmentsSheetRouteWithChildren
}

const departmentsDepartmentsRouteChildren: departmentsDepartmentsRouteChildren =
  {
    departmentsDepartmentsSheetRoute:
      departmentsDepartmentsSheetRouteWithChildren,
  }

const departmentsDepartmentsRouteWithChildren =
  departmentsDepartmentsRoute._addFileChildren(
    departmentsDepartmentsRouteChildren,
  )

interface guidesGuidesSheetRouteChildren {
  guidesGuidesSheetNewRoute: typeof guidesGuidesSheetNewRoute
  guidesGuidesSheetIdEditRoute: typeof guidesGuidesSheetIdEditRoute
  guidesGuidesSheetIdIndexRoute: typeof guidesGuidesSheetIdIndexRoute
}

const guidesGuidesSheetRouteChildren: guidesGuidesSheetRouteChildren = {
  guidesGuidesSheetNewRoute: guidesGuidesSheetNewRoute,
  guidesGuidesSheetIdEditRoute: guidesGuidesSheetIdEditRoute,
  guidesGuidesSheetIdIndexRoute: guidesGuidesSheetIdIndexRoute,
}

const guidesGuidesSheetRouteWithChildren =
  guidesGuidesSheetRoute._addFileChildren(guidesGuidesSheetRouteChildren)

interface guidesGuidesRouteChildren {
  guidesGuidesSheetRoute: typeof guidesGuidesSheetRouteWithChildren
}

const guidesGuidesRouteChildren: guidesGuidesRouteChildren = {
  guidesGuidesSheetRoute: guidesGuidesSheetRouteWithChildren,
}

const guidesGuidesRouteWithChildren = guidesGuidesRoute._addFileChildren(
  guidesGuidesRouteChildren,
)

interface hotelsHotelsSheetRouteChildren {
  hotelsHotelsSheetNewRoute: typeof hotelsHotelsSheetNewRoute
  hotelsHotelsSheetIdEditRoute: typeof hotelsHotelsSheetIdEditRoute
  hotelsHotelsSheetIdIndexRoute: typeof hotelsHotelsSheetIdIndexRoute
}

const hotelsHotelsSheetRouteChildren: hotelsHotelsSheetRouteChildren = {
  hotelsHotelsSheetNewRoute: hotelsHotelsSheetNewRoute,
  hotelsHotelsSheetIdEditRoute: hotelsHotelsSheetIdEditRoute,
  hotelsHotelsSheetIdIndexRoute: hotelsHotelsSheetIdIndexRoute,
}

const hotelsHotelsSheetRouteWithChildren =
  hotelsHotelsSheetRoute._addFileChildren(hotelsHotelsSheetRouteChildren)

interface hotelsHotelsRouteChildren {
  hotelsHotelsSheetRoute: typeof hotelsHotelsSheetRouteWithChildren
}

const hotelsHotelsRouteChildren: hotelsHotelsRouteChildren = {
  hotelsHotelsSheetRoute: hotelsHotelsSheetRouteWithChildren,
}

const hotelsHotelsRouteWithChildren = hotelsHotelsRoute._addFileChildren(
  hotelsHotelsRouteChildren,
)

interface providersProvidersSheetRouteChildren {
  providersProvidersSheetNewRoute: typeof providersProvidersSheetNewRoute
  providersProvidersSheetIdEditRoute: typeof providersProvidersSheetIdEditRoute
  providersProvidersSheetIdIndexRoute: typeof providersProvidersSheetIdIndexRoute
}

const providersProvidersSheetRouteChildren: providersProvidersSheetRouteChildren =
  {
    providersProvidersSheetNewRoute: providersProvidersSheetNewRoute,
    providersProvidersSheetIdEditRoute: providersProvidersSheetIdEditRoute,
    providersProvidersSheetIdIndexRoute: providersProvidersSheetIdIndexRoute,
  }

const providersProvidersSheetRouteWithChildren =
  providersProvidersSheetRoute._addFileChildren(
    providersProvidersSheetRouteChildren,
  )

interface providersProvidersRouteChildren {
  providersProvidersSheetRoute: typeof providersProvidersSheetRouteWithChildren
}

const providersProvidersRouteChildren: providersProvidersRouteChildren = {
  providersProvidersSheetRoute: providersProvidersSheetRouteWithChildren,
}

const providersProvidersRouteWithChildren =
  providersProvidersRoute._addFileChildren(providersProvidersRouteChildren)

interface regionsRegionsSheetRouteChildren {
  regionsRegionsSheetNewRoute: typeof regionsRegionsSheetNewRoute
  regionsRegionsSheetIdEditRoute: typeof regionsRegionsSheetIdEditRoute
  regionsRegionsSheetIdIndexRoute: typeof regionsRegionsSheetIdIndexRoute
}

const regionsRegionsSheetRouteChildren: regionsRegionsSheetRouteChildren = {
  regionsRegionsSheetNewRoute: regionsRegionsSheetNewRoute,
  regionsRegionsSheetIdEditRoute: regionsRegionsSheetIdEditRoute,
  regionsRegionsSheetIdIndexRoute: regionsRegionsSheetIdIndexRoute,
}

const regionsRegionsSheetRouteWithChildren =
  regionsRegionsSheetRoute._addFileChildren(regionsRegionsSheetRouteChildren)

interface regionsRegionsRouteChildren {
  regionsRegionsSheetRoute: typeof regionsRegionsSheetRouteWithChildren
}

const regionsRegionsRouteChildren: regionsRegionsRouteChildren = {
  regionsRegionsSheetRoute: regionsRegionsSheetRouteWithChildren,
}

const regionsRegionsRouteWithChildren = regionsRegionsRoute._addFileChildren(
  regionsRegionsRouteChildren,
)

interface servicesServicesSheetRouteChildren {
  servicesServicesSheetNewRoute: typeof servicesServicesSheetNewRoute
  servicesServicesSheetIdEditRoute: typeof servicesServicesSheetIdEditRoute
  servicesServicesSheetIdIndexRoute: typeof servicesServicesSheetIdIndexRoute
}

const servicesServicesSheetRouteChildren: servicesServicesSheetRouteChildren = {
  servicesServicesSheetNewRoute: servicesServicesSheetNewRoute,
  servicesServicesSheetIdEditRoute: servicesServicesSheetIdEditRoute,
  servicesServicesSheetIdIndexRoute: servicesServicesSheetIdIndexRoute,
}

const servicesServicesSheetRouteWithChildren =
  servicesServicesSheetRoute._addFileChildren(
    servicesServicesSheetRouteChildren,
  )

interface servicesServicesRouteChildren {
  servicesServicesSheetRoute: typeof servicesServicesSheetRouteWithChildren
}

const servicesServicesRouteChildren: servicesServicesRouteChildren = {
  servicesServicesSheetRoute: servicesServicesSheetRouteWithChildren,
}

const servicesServicesRouteWithChildren =
  servicesServicesRoute._addFileChildren(servicesServicesRouteChildren)

interface toursToursSheetRouteChildren {
  toursToursSheetNewRoute: typeof toursToursSheetNewRoute
  toursToursSheetIdEditRoute: typeof toursToursSheetIdEditRoute
  toursToursSheetIdIndexRoute: typeof toursToursSheetIdIndexRoute
}

const toursToursSheetRouteChildren: toursToursSheetRouteChildren = {
  toursToursSheetNewRoute: toursToursSheetNewRoute,
  toursToursSheetIdEditRoute: toursToursSheetIdEditRoute,
  toursToursSheetIdIndexRoute: toursToursSheetIdIndexRoute,
}

const toursToursSheetRouteWithChildren = toursToursSheetRoute._addFileChildren(
  toursToursSheetRouteChildren,
)

interface toursToursRouteChildren {
  toursToursSheetRoute: typeof toursToursSheetRouteWithChildren
}

const toursToursRouteChildren: toursToursRouteChildren = {
  toursToursSheetRoute: toursToursSheetRouteWithChildren,
}

const toursToursRouteWithChildren = toursToursRoute._addFileChildren(
  toursToursRouteChildren,
)

interface workersWorkersSheetRouteChildren {
  workersWorkersSheetNewRoute: typeof workersWorkersSheetNewRoute
  workersWorkersSheetIdEditRoute: typeof workersWorkersSheetIdEditRoute
  workersWorkersSheetIdIndexRoute: typeof workersWorkersSheetIdIndexRoute
}

const workersWorkersSheetRouteChildren: workersWorkersSheetRouteChildren = {
  workersWorkersSheetNewRoute: workersWorkersSheetNewRoute,
  workersWorkersSheetIdEditRoute: workersWorkersSheetIdEditRoute,
  workersWorkersSheetIdIndexRoute: workersWorkersSheetIdIndexRoute,
}

const workersWorkersSheetRouteWithChildren =
  workersWorkersSheetRoute._addFileChildren(workersWorkersSheetRouteChildren)

interface workersWorkersRouteChildren {
  workersWorkersSheetRoute: typeof workersWorkersSheetRouteWithChildren
}

const workersWorkersRouteChildren: workersWorkersRouteChildren = {
  workersWorkersSheetRoute: workersWorkersSheetRouteWithChildren,
}

const workersWorkersRouteWithChildren = workersWorkersRoute._addFileChildren(
  workersWorkersRouteChildren,
)

interface hotelRoomsHotelRoomsIdSheetRouteChildren {
  hotelRoomsHotelRoomsIdSheetRidRoute: typeof hotelRoomsHotelRoomsIdSheetRidRoute
  hotelRoomsHotelRoomsIdSheetNewRoute: typeof hotelRoomsHotelRoomsIdSheetNewRoute
}

const hotelRoomsHotelRoomsIdSheetRouteChildren: hotelRoomsHotelRoomsIdSheetRouteChildren =
  {
    hotelRoomsHotelRoomsIdSheetRidRoute: hotelRoomsHotelRoomsIdSheetRidRoute,
    hotelRoomsHotelRoomsIdSheetNewRoute: hotelRoomsHotelRoomsIdSheetNewRoute,
  }

const hotelRoomsHotelRoomsIdSheetRouteWithChildren =
  hotelRoomsHotelRoomsIdSheetRoute._addFileChildren(
    hotelRoomsHotelRoomsIdSheetRouteChildren,
  )

interface hotelRoomsHotelRoomsIdRouteChildren {
  hotelRoomsHotelRoomsIdSheetRoute: typeof hotelRoomsHotelRoomsIdSheetRouteWithChildren
}

const hotelRoomsHotelRoomsIdRouteChildren: hotelRoomsHotelRoomsIdRouteChildren =
  {
    hotelRoomsHotelRoomsIdSheetRoute:
      hotelRoomsHotelRoomsIdSheetRouteWithChildren,
  }

const hotelRoomsHotelRoomsIdRouteWithChildren =
  hotelRoomsHotelRoomsIdRoute._addFileChildren(
    hotelRoomsHotelRoomsIdRouteChildren,
  )

interface serviceProvidersServiceProvidersIdSheetRouteChildren {
  serviceProvidersServiceProvidersIdSheetNewRoute: typeof serviceProvidersServiceProvidersIdSheetNewRoute
  serviceProvidersServiceProvidersIdSheetEditSpIdRoute: typeof serviceProvidersServiceProvidersIdSheetEditSpIdRoute
}

const serviceProvidersServiceProvidersIdSheetRouteChildren: serviceProvidersServiceProvidersIdSheetRouteChildren =
  {
    serviceProvidersServiceProvidersIdSheetNewRoute:
      serviceProvidersServiceProvidersIdSheetNewRoute,
    serviceProvidersServiceProvidersIdSheetEditSpIdRoute:
      serviceProvidersServiceProvidersIdSheetEditSpIdRoute,
  }

const serviceProvidersServiceProvidersIdSheetRouteWithChildren =
  serviceProvidersServiceProvidersIdSheetRoute._addFileChildren(
    serviceProvidersServiceProvidersIdSheetRouteChildren,
  )

interface serviceProvidersServiceProvidersIdRouteChildren {
  serviceProvidersServiceProvidersIdSheetRoute: typeof serviceProvidersServiceProvidersIdSheetRouteWithChildren
}

const serviceProvidersServiceProvidersIdRouteChildren: serviceProvidersServiceProvidersIdRouteChildren =
  {
    serviceProvidersServiceProvidersIdSheetRoute:
      serviceProvidersServiceProvidersIdSheetRouteWithChildren,
  }

const serviceProvidersServiceProvidersIdRouteWithChildren =
  serviceProvidersServiceProvidersIdRoute._addFileChildren(
    serviceProvidersServiceProvidersIdRouteChildren,
  )

interface tourAgenciesTourAgenciesIdSheetRouteChildren {
  tourAgenciesTourAgenciesIdSheetNewRoute: typeof tourAgenciesTourAgenciesIdSheetNewRoute
  tourAgenciesTourAgenciesIdSheetEditTaIdRoute: typeof tourAgenciesTourAgenciesIdSheetEditTaIdRoute
}

const tourAgenciesTourAgenciesIdSheetRouteChildren: tourAgenciesTourAgenciesIdSheetRouteChildren =
  {
    tourAgenciesTourAgenciesIdSheetNewRoute:
      tourAgenciesTourAgenciesIdSheetNewRoute,
    tourAgenciesTourAgenciesIdSheetEditTaIdRoute:
      tourAgenciesTourAgenciesIdSheetEditTaIdRoute,
  }

const tourAgenciesTourAgenciesIdSheetRouteWithChildren =
  tourAgenciesTourAgenciesIdSheetRoute._addFileChildren(
    tourAgenciesTourAgenciesIdSheetRouteChildren,
  )

interface tourAgenciesTourAgenciesIdRouteChildren {
  tourAgenciesTourAgenciesIdSheetRoute: typeof tourAgenciesTourAgenciesIdSheetRouteWithChildren
}

const tourAgenciesTourAgenciesIdRouteChildren: tourAgenciesTourAgenciesIdRouteChildren =
  {
    tourAgenciesTourAgenciesIdSheetRoute:
      tourAgenciesTourAgenciesIdSheetRouteWithChildren,
  }

const tourAgenciesTourAgenciesIdRouteWithChildren =
  tourAgenciesTourAgenciesIdRoute._addFileChildren(
    tourAgenciesTourAgenciesIdRouteChildren,
  )

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute
  "/agencies": typeof agenciesAgenciesSheetRouteWithChildren
  "/departments": typeof departmentsDepartmentsSheetRouteWithChildren
  "/guides": typeof guidesGuidesSheetRouteWithChildren
  "/hotels": typeof hotelsHotelsSheetRouteWithChildren
  "/operations": typeof operationsOperationsRoute
  "/providers": typeof providersProvidersSheetRouteWithChildren
  "/regions": typeof regionsRegionsSheetRouteWithChildren
  "/services": typeof servicesServicesSheetRouteWithChildren
  "/tours": typeof toursToursSheetRouteWithChildren
  "/workers": typeof workersWorkersSheetRouteWithChildren
  "/hotel-rooms/$id": typeof hotelRoomsHotelRoomsIdSheetRouteWithChildren
  "/reservations/new": typeof reservationsReservationsNewRoute
  "/service-providers/$id": typeof serviceProvidersServiceProvidersIdSheetRouteWithChildren
  "/tour-agencies/$id": typeof tourAgenciesTourAgenciesIdSheetRouteWithChildren
  "/tour-days/$id": typeof tourDaysTourDaysIdRoute
  "/reservations": typeof reservationsReservationsIndexRoute
  "/agencies/new": typeof agenciesAgenciesSheetNewRoute
  "/departments/new": typeof departmentsDepartmentsSheetNewRoute
  "/guides/new": typeof guidesGuidesSheetNewRoute
  "/hotels/new": typeof hotelsHotelsSheetNewRoute
  "/providers/new": typeof providersProvidersSheetNewRoute
  "/regions/new": typeof regionsRegionsSheetNewRoute
  "/reservations/$id/edit": typeof reservationsReservationsIdEditRoute
  "/reservations/$id/fulfillments": typeof reservationsReservationsIdFulfillmentsRoute
  "/services/new": typeof servicesServicesSheetNewRoute
  "/tours/new": typeof toursToursSheetNewRoute
  "/workers/new": typeof workersWorkersSheetNewRoute
  "/reservations/$id": typeof reservationsReservationsIdIndexRoute
  "/reservations/calendar": typeof reservationsReservationsCalendarIndexRoute
  "/agencies/$id/edit": typeof agenciesAgenciesSheetIdEditRoute
  "/departments/$id/edit": typeof departmentsDepartmentsSheetIdEditRoute
  "/guides/$id/edit": typeof guidesGuidesSheetIdEditRoute
  "/hotel-rooms/$id/$rid": typeof hotelRoomsHotelRoomsIdSheetRidRoute
  "/hotel-rooms/$id/new": typeof hotelRoomsHotelRoomsIdSheetNewRoute
  "/hotels/$id/edit": typeof hotelsHotelsSheetIdEditRoute
  "/providers/$id/edit": typeof providersProvidersSheetIdEditRoute
  "/regions/$id/edit": typeof regionsRegionsSheetIdEditRoute
  "/reservations/calendar/$id/edit": typeof reservationsReservationsCalendarIdEditRoute
  "/reservations/calendar/$id/fulfillments": typeof reservationsReservationsCalendarIdFulfillmentsRoute
  "/service-providers/$id/new": typeof serviceProvidersServiceProvidersIdSheetNewRoute
  "/services/$id/edit": typeof servicesServicesSheetIdEditRoute
  "/tour-agencies/$id/new": typeof tourAgenciesTourAgenciesIdSheetNewRoute
  "/tours/$id/edit": typeof toursToursSheetIdEditRoute
  "/workers/$id/edit": typeof workersWorkersSheetIdEditRoute
  "/agencies/$id": typeof agenciesAgenciesSheetIdIndexRoute
  "/departments/$id": typeof departmentsDepartmentsSheetIdIndexRoute
  "/guides/$id": typeof guidesGuidesSheetIdIndexRoute
  "/hotels/$id": typeof hotelsHotelsSheetIdIndexRoute
  "/providers/$id": typeof providersProvidersSheetIdIndexRoute
  "/regions/$id": typeof regionsRegionsSheetIdIndexRoute
  "/reservations/calendar/$id": typeof reservationsReservationsCalendarIdIndexRoute
  "/reservations/calendar/new": typeof reservationsReservationsCalendarNewIndexRoute
  "/services/$id": typeof servicesServicesSheetIdIndexRoute
  "/tours/$id": typeof toursToursSheetIdIndexRoute
  "/workers/$id": typeof workersWorkersSheetIdIndexRoute
  "/service-providers/$id/edit/$spId": typeof serviceProvidersServiceProvidersIdSheetEditSpIdRoute
  "/tour-agencies/$id/edit/$taId": typeof tourAgenciesTourAgenciesIdSheetEditTaIdRoute
}

export interface FileRoutesByTo {
  "/": typeof IndexRoute
  "/agencies": typeof agenciesAgenciesSheetRouteWithChildren
  "/departments": typeof departmentsDepartmentsSheetRouteWithChildren
  "/guides": typeof guidesGuidesSheetRouteWithChildren
  "/hotels": typeof hotelsHotelsSheetRouteWithChildren
  "/operations": typeof operationsOperationsRoute
  "/providers": typeof providersProvidersSheetRouteWithChildren
  "/regions": typeof regionsRegionsSheetRouteWithChildren
  "/services": typeof servicesServicesSheetRouteWithChildren
  "/tours": typeof toursToursSheetRouteWithChildren
  "/workers": typeof workersWorkersSheetRouteWithChildren
  "/hotel-rooms/$id": typeof hotelRoomsHotelRoomsIdSheetRouteWithChildren
  "/reservations/new": typeof reservationsReservationsNewRoute
  "/service-providers/$id": typeof serviceProvidersServiceProvidersIdSheetRouteWithChildren
  "/tour-agencies/$id": typeof tourAgenciesTourAgenciesIdSheetRouteWithChildren
  "/tour-days/$id": typeof tourDaysTourDaysIdRoute
  "/reservations": typeof reservationsReservationsIndexRoute
  "/agencies/new": typeof agenciesAgenciesSheetNewRoute
  "/departments/new": typeof departmentsDepartmentsSheetNewRoute
  "/guides/new": typeof guidesGuidesSheetNewRoute
  "/hotels/new": typeof hotelsHotelsSheetNewRoute
  "/providers/new": typeof providersProvidersSheetNewRoute
  "/regions/new": typeof regionsRegionsSheetNewRoute
  "/reservations/$id/edit": typeof reservationsReservationsIdEditRoute
  "/reservations/$id/fulfillments": typeof reservationsReservationsIdFulfillmentsRoute
  "/services/new": typeof servicesServicesSheetNewRoute
  "/tours/new": typeof toursToursSheetNewRoute
  "/workers/new": typeof workersWorkersSheetNewRoute
  "/reservations/$id": typeof reservationsReservationsIdIndexRoute
  "/reservations/calendar": typeof reservationsReservationsCalendarIndexRoute
  "/agencies/$id/edit": typeof agenciesAgenciesSheetIdEditRoute
  "/departments/$id/edit": typeof departmentsDepartmentsSheetIdEditRoute
  "/guides/$id/edit": typeof guidesGuidesSheetIdEditRoute
  "/hotel-rooms/$id/$rid": typeof hotelRoomsHotelRoomsIdSheetRidRoute
  "/hotel-rooms/$id/new": typeof hotelRoomsHotelRoomsIdSheetNewRoute
  "/hotels/$id/edit": typeof hotelsHotelsSheetIdEditRoute
  "/providers/$id/edit": typeof providersProvidersSheetIdEditRoute
  "/regions/$id/edit": typeof regionsRegionsSheetIdEditRoute
  "/reservations/calendar/$id/edit": typeof reservationsReservationsCalendarIdEditRoute
  "/reservations/calendar/$id/fulfillments": typeof reservationsReservationsCalendarIdFulfillmentsRoute
  "/service-providers/$id/new": typeof serviceProvidersServiceProvidersIdSheetNewRoute
  "/services/$id/edit": typeof servicesServicesSheetIdEditRoute
  "/tour-agencies/$id/new": typeof tourAgenciesTourAgenciesIdSheetNewRoute
  "/tours/$id/edit": typeof toursToursSheetIdEditRoute
  "/workers/$id/edit": typeof workersWorkersSheetIdEditRoute
  "/agencies/$id": typeof agenciesAgenciesSheetIdIndexRoute
  "/departments/$id": typeof departmentsDepartmentsSheetIdIndexRoute
  "/guides/$id": typeof guidesGuidesSheetIdIndexRoute
  "/hotels/$id": typeof hotelsHotelsSheetIdIndexRoute
  "/providers/$id": typeof providersProvidersSheetIdIndexRoute
  "/regions/$id": typeof regionsRegionsSheetIdIndexRoute
  "/reservations/calendar/$id": typeof reservationsReservationsCalendarIdIndexRoute
  "/reservations/calendar/new": typeof reservationsReservationsCalendarNewIndexRoute
  "/services/$id": typeof servicesServicesSheetIdIndexRoute
  "/tours/$id": typeof toursToursSheetIdIndexRoute
  "/workers/$id": typeof workersWorkersSheetIdIndexRoute
  "/service-providers/$id/edit/$spId": typeof serviceProvidersServiceProvidersIdSheetEditSpIdRoute
  "/tour-agencies/$id/edit/$taId": typeof tourAgenciesTourAgenciesIdSheetEditTaIdRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  "/": typeof IndexRoute
  "/(agencies)/agencies": typeof agenciesAgenciesRouteWithChildren
  "/(departments)/departments": typeof departmentsDepartmentsRouteWithChildren
  "/(guides)/guides": typeof guidesGuidesRouteWithChildren
  "/(hotels)/hotels": typeof hotelsHotelsRouteWithChildren
  "/(operations)/operations": typeof operationsOperationsRoute
  "/(providers)/providers": typeof providersProvidersRouteWithChildren
  "/(regions)/regions": typeof regionsRegionsRouteWithChildren
  "/(services)/services": typeof servicesServicesRouteWithChildren
  "/(tours)/tours": typeof toursToursRouteWithChildren
  "/(workers)/workers": typeof workersWorkersRouteWithChildren
  "/(agencies)/agencies/_sheet": typeof agenciesAgenciesSheetRouteWithChildren
  "/(departments)/departments/_sheet": typeof departmentsDepartmentsSheetRouteWithChildren
  "/(guides)/guides/_sheet": typeof guidesGuidesSheetRouteWithChildren
  "/(hotel-rooms)/hotel-rooms/$id": typeof hotelRoomsHotelRoomsIdRouteWithChildren
  "/(hotels)/hotels/_sheet": typeof hotelsHotelsSheetRouteWithChildren
  "/(providers)/providers/_sheet": typeof providersProvidersSheetRouteWithChildren
  "/(regions)/regions/_sheet": typeof regionsRegionsSheetRouteWithChildren
  "/(reservations)/reservations/new": typeof reservationsReservationsNewRoute
  "/(service-providers)/service-providers/$id": typeof serviceProvidersServiceProvidersIdRouteWithChildren
  "/(services)/services/_sheet": typeof servicesServicesSheetRouteWithChildren
  "/(tour-agencies)/tour-agencies/$id": typeof tourAgenciesTourAgenciesIdRouteWithChildren
  "/(tour-days)/tour-days/$id": typeof tourDaysTourDaysIdRoute
  "/(tours)/tours/_sheet": typeof toursToursSheetRouteWithChildren
  "/(workers)/workers/_sheet": typeof workersWorkersSheetRouteWithChildren
  "/(reservations)/reservations/": typeof reservationsReservationsIndexRoute
  "/(agencies)/agencies/_sheet/new": typeof agenciesAgenciesSheetNewRoute
  "/(departments)/departments/_sheet/new": typeof departmentsDepartmentsSheetNewRoute
  "/(guides)/guides/_sheet/new": typeof guidesGuidesSheetNewRoute
  "/(hotel-rooms)/hotel-rooms/$id/_sheet": typeof hotelRoomsHotelRoomsIdSheetRouteWithChildren
  "/(hotels)/hotels/_sheet/new": typeof hotelsHotelsSheetNewRoute
  "/(providers)/providers/_sheet/new": typeof providersProvidersSheetNewRoute
  "/(regions)/regions/_sheet/new": typeof regionsRegionsSheetNewRoute
  "/(reservations)/reservations/$id/edit": typeof reservationsReservationsIdEditRoute
  "/(reservations)/reservations/$id/fulfillments": typeof reservationsReservationsIdFulfillmentsRoute
  "/(service-providers)/service-providers/$id/_sheet": typeof serviceProvidersServiceProvidersIdSheetRouteWithChildren
  "/(services)/services/_sheet/new": typeof servicesServicesSheetNewRoute
  "/(tour-agencies)/tour-agencies/$id/_sheet": typeof tourAgenciesTourAgenciesIdSheetRouteWithChildren
  "/(tours)/tours/_sheet/new": typeof toursToursSheetNewRoute
  "/(workers)/workers/_sheet/new": typeof workersWorkersSheetNewRoute
  "/(reservations)/reservations/$id/": typeof reservationsReservationsIdIndexRoute
  "/(reservations)/reservations/calendar/": typeof reservationsReservationsCalendarIndexRoute
  "/(agencies)/agencies/_sheet/$id/edit": typeof agenciesAgenciesSheetIdEditRoute
  "/(departments)/departments/_sheet/$id/edit": typeof departmentsDepartmentsSheetIdEditRoute
  "/(guides)/guides/_sheet/$id/edit": typeof guidesGuidesSheetIdEditRoute
  "/(hotel-rooms)/hotel-rooms/$id/_sheet/$rid": typeof hotelRoomsHotelRoomsIdSheetRidRoute
  "/(hotel-rooms)/hotel-rooms/$id/_sheet/new": typeof hotelRoomsHotelRoomsIdSheetNewRoute
  "/(hotels)/hotels/_sheet/$id/edit": typeof hotelsHotelsSheetIdEditRoute
  "/(providers)/providers/_sheet/$id/edit": typeof providersProvidersSheetIdEditRoute
  "/(regions)/regions/_sheet/$id/edit": typeof regionsRegionsSheetIdEditRoute
  "/(reservations)/reservations/calendar/$id/edit": typeof reservationsReservationsCalendarIdEditRoute
  "/(reservations)/reservations/calendar/$id/fulfillments": typeof reservationsReservationsCalendarIdFulfillmentsRoute
  "/(service-providers)/service-providers/$id/_sheet/new": typeof serviceProvidersServiceProvidersIdSheetNewRoute
  "/(services)/services/_sheet/$id/edit": typeof servicesServicesSheetIdEditRoute
  "/(tour-agencies)/tour-agencies/$id/_sheet/new": typeof tourAgenciesTourAgenciesIdSheetNewRoute
  "/(tours)/tours/_sheet/$id/edit": typeof toursToursSheetIdEditRoute
  "/(workers)/workers/_sheet/$id/edit": typeof workersWorkersSheetIdEditRoute
  "/(agencies)/agencies/_sheet/$id/": typeof agenciesAgenciesSheetIdIndexRoute
  "/(departments)/departments/_sheet/$id/": typeof departmentsDepartmentsSheetIdIndexRoute
  "/(guides)/guides/_sheet/$id/": typeof guidesGuidesSheetIdIndexRoute
  "/(hotels)/hotels/_sheet/$id/": typeof hotelsHotelsSheetIdIndexRoute
  "/(providers)/providers/_sheet/$id/": typeof providersProvidersSheetIdIndexRoute
  "/(regions)/regions/_sheet/$id/": typeof regionsRegionsSheetIdIndexRoute
  "/(reservations)/reservations/calendar/$id/": typeof reservationsReservationsCalendarIdIndexRoute
  "/(reservations)/reservations/calendar/new/": typeof reservationsReservationsCalendarNewIndexRoute
  "/(services)/services/_sheet/$id/": typeof servicesServicesSheetIdIndexRoute
  "/(tours)/tours/_sheet/$id/": typeof toursToursSheetIdIndexRoute
  "/(workers)/workers/_sheet/$id/": typeof workersWorkersSheetIdIndexRoute
  "/(service-providers)/service-providers/$id/_sheet/edit/$spId": typeof serviceProvidersServiceProvidersIdSheetEditSpIdRoute
  "/(tour-agencies)/tour-agencies/$id/_sheet/edit/$taId": typeof tourAgenciesTourAgenciesIdSheetEditTaIdRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | "/"
    | "/agencies"
    | "/departments"
    | "/guides"
    | "/hotels"
    | "/operations"
    | "/providers"
    | "/regions"
    | "/services"
    | "/tours"
    | "/workers"
    | "/hotel-rooms/$id"
    | "/reservations/new"
    | "/service-providers/$id"
    | "/tour-agencies/$id"
    | "/tour-days/$id"
    | "/reservations"
    | "/agencies/new"
    | "/departments/new"
    | "/guides/new"
    | "/hotels/new"
    | "/providers/new"
    | "/regions/new"
    | "/reservations/$id/edit"
    | "/reservations/$id/fulfillments"
    | "/services/new"
    | "/tours/new"
    | "/workers/new"
    | "/reservations/$id"
    | "/reservations/calendar"
    | "/agencies/$id/edit"
    | "/departments/$id/edit"
    | "/guides/$id/edit"
    | "/hotel-rooms/$id/$rid"
    | "/hotel-rooms/$id/new"
    | "/hotels/$id/edit"
    | "/providers/$id/edit"
    | "/regions/$id/edit"
    | "/reservations/calendar/$id/edit"
    | "/reservations/calendar/$id/fulfillments"
    | "/service-providers/$id/new"
    | "/services/$id/edit"
    | "/tour-agencies/$id/new"
    | "/tours/$id/edit"
    | "/workers/$id/edit"
    | "/agencies/$id"
    | "/departments/$id"
    | "/guides/$id"
    | "/hotels/$id"
    | "/providers/$id"
    | "/regions/$id"
    | "/reservations/calendar/$id"
    | "/reservations/calendar/new"
    | "/services/$id"
    | "/tours/$id"
    | "/workers/$id"
    | "/service-providers/$id/edit/$spId"
    | "/tour-agencies/$id/edit/$taId"
  fileRoutesByTo: FileRoutesByTo
  to:
    | "/"
    | "/agencies"
    | "/departments"
    | "/guides"
    | "/hotels"
    | "/operations"
    | "/providers"
    | "/regions"
    | "/services"
    | "/tours"
    | "/workers"
    | "/hotel-rooms/$id"
    | "/reservations/new"
    | "/service-providers/$id"
    | "/tour-agencies/$id"
    | "/tour-days/$id"
    | "/reservations"
    | "/agencies/new"
    | "/departments/new"
    | "/guides/new"
    | "/hotels/new"
    | "/providers/new"
    | "/regions/new"
    | "/reservations/$id/edit"
    | "/reservations/$id/fulfillments"
    | "/services/new"
    | "/tours/new"
    | "/workers/new"
    | "/reservations/$id"
    | "/reservations/calendar"
    | "/agencies/$id/edit"
    | "/departments/$id/edit"
    | "/guides/$id/edit"
    | "/hotel-rooms/$id/$rid"
    | "/hotel-rooms/$id/new"
    | "/hotels/$id/edit"
    | "/providers/$id/edit"
    | "/regions/$id/edit"
    | "/reservations/calendar/$id/edit"
    | "/reservations/calendar/$id/fulfillments"
    | "/service-providers/$id/new"
    | "/services/$id/edit"
    | "/tour-agencies/$id/new"
    | "/tours/$id/edit"
    | "/workers/$id/edit"
    | "/agencies/$id"
    | "/departments/$id"
    | "/guides/$id"
    | "/hotels/$id"
    | "/providers/$id"
    | "/regions/$id"
    | "/reservations/calendar/$id"
    | "/reservations/calendar/new"
    | "/services/$id"
    | "/tours/$id"
    | "/workers/$id"
    | "/service-providers/$id/edit/$spId"
    | "/tour-agencies/$id/edit/$taId"
  id:
    | "__root__"
    | "/"
    | "/(agencies)/agencies"
    | "/(departments)/departments"
    | "/(guides)/guides"
    | "/(hotels)/hotels"
    | "/(operations)/operations"
    | "/(providers)/providers"
    | "/(regions)/regions"
    | "/(services)/services"
    | "/(tours)/tours"
    | "/(workers)/workers"
    | "/(agencies)/agencies/_sheet"
    | "/(departments)/departments/_sheet"
    | "/(guides)/guides/_sheet"
    | "/(hotel-rooms)/hotel-rooms/$id"
    | "/(hotels)/hotels/_sheet"
    | "/(providers)/providers/_sheet"
    | "/(regions)/regions/_sheet"
    | "/(reservations)/reservations/new"
    | "/(service-providers)/service-providers/$id"
    | "/(services)/services/_sheet"
    | "/(tour-agencies)/tour-agencies/$id"
    | "/(tour-days)/tour-days/$id"
    | "/(tours)/tours/_sheet"
    | "/(workers)/workers/_sheet"
    | "/(reservations)/reservations/"
    | "/(agencies)/agencies/_sheet/new"
    | "/(departments)/departments/_sheet/new"
    | "/(guides)/guides/_sheet/new"
    | "/(hotel-rooms)/hotel-rooms/$id/_sheet"
    | "/(hotels)/hotels/_sheet/new"
    | "/(providers)/providers/_sheet/new"
    | "/(regions)/regions/_sheet/new"
    | "/(reservations)/reservations/$id/edit"
    | "/(reservations)/reservations/$id/fulfillments"
    | "/(service-providers)/service-providers/$id/_sheet"
    | "/(services)/services/_sheet/new"
    | "/(tour-agencies)/tour-agencies/$id/_sheet"
    | "/(tours)/tours/_sheet/new"
    | "/(workers)/workers/_sheet/new"
    | "/(reservations)/reservations/$id/"
    | "/(reservations)/reservations/calendar/"
    | "/(agencies)/agencies/_sheet/$id/edit"
    | "/(departments)/departments/_sheet/$id/edit"
    | "/(guides)/guides/_sheet/$id/edit"
    | "/(hotel-rooms)/hotel-rooms/$id/_sheet/$rid"
    | "/(hotel-rooms)/hotel-rooms/$id/_sheet/new"
    | "/(hotels)/hotels/_sheet/$id/edit"
    | "/(providers)/providers/_sheet/$id/edit"
    | "/(regions)/regions/_sheet/$id/edit"
    | "/(reservations)/reservations/calendar/$id/edit"
    | "/(reservations)/reservations/calendar/$id/fulfillments"
    | "/(service-providers)/service-providers/$id/_sheet/new"
    | "/(services)/services/_sheet/$id/edit"
    | "/(tour-agencies)/tour-agencies/$id/_sheet/new"
    | "/(tours)/tours/_sheet/$id/edit"
    | "/(workers)/workers/_sheet/$id/edit"
    | "/(agencies)/agencies/_sheet/$id/"
    | "/(departments)/departments/_sheet/$id/"
    | "/(guides)/guides/_sheet/$id/"
    | "/(hotels)/hotels/_sheet/$id/"
    | "/(providers)/providers/_sheet/$id/"
    | "/(regions)/regions/_sheet/$id/"
    | "/(reservations)/reservations/calendar/$id/"
    | "/(reservations)/reservations/calendar/new/"
    | "/(services)/services/_sheet/$id/"
    | "/(tours)/tours/_sheet/$id/"
    | "/(workers)/workers/_sheet/$id/"
    | "/(service-providers)/service-providers/$id/_sheet/edit/$spId"
    | "/(tour-agencies)/tour-agencies/$id/_sheet/edit/$taId"
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  agenciesAgenciesRoute: typeof agenciesAgenciesRouteWithChildren
  departmentsDepartmentsRoute: typeof departmentsDepartmentsRouteWithChildren
  guidesGuidesRoute: typeof guidesGuidesRouteWithChildren
  hotelsHotelsRoute: typeof hotelsHotelsRouteWithChildren
  operationsOperationsRoute: typeof operationsOperationsRoute
  providersProvidersRoute: typeof providersProvidersRouteWithChildren
  regionsRegionsRoute: typeof regionsRegionsRouteWithChildren
  servicesServicesRoute: typeof servicesServicesRouteWithChildren
  toursToursRoute: typeof toursToursRouteWithChildren
  workersWorkersRoute: typeof workersWorkersRouteWithChildren
  hotelRoomsHotelRoomsIdRoute: typeof hotelRoomsHotelRoomsIdRouteWithChildren
  reservationsReservationsNewRoute: typeof reservationsReservationsNewRoute
  serviceProvidersServiceProvidersIdRoute: typeof serviceProvidersServiceProvidersIdRouteWithChildren
  tourAgenciesTourAgenciesIdRoute: typeof tourAgenciesTourAgenciesIdRouteWithChildren
  tourDaysTourDaysIdRoute: typeof tourDaysTourDaysIdRoute
  reservationsReservationsIndexRoute: typeof reservationsReservationsIndexRoute
  reservationsReservationsIdEditRoute: typeof reservationsReservationsIdEditRoute
  reservationsReservationsIdFulfillmentsRoute: typeof reservationsReservationsIdFulfillmentsRoute
  reservationsReservationsIdIndexRoute: typeof reservationsReservationsIdIndexRoute
  reservationsReservationsCalendarIndexRoute: typeof reservationsReservationsCalendarIndexRoute
  reservationsReservationsCalendarIdEditRoute: typeof reservationsReservationsCalendarIdEditRoute
  reservationsReservationsCalendarIdFulfillmentsRoute: typeof reservationsReservationsCalendarIdFulfillmentsRoute
  reservationsReservationsCalendarIdIndexRoute: typeof reservationsReservationsCalendarIdIndexRoute
  reservationsReservationsCalendarNewIndexRoute: typeof reservationsReservationsCalendarNewIndexRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  agenciesAgenciesRoute: agenciesAgenciesRouteWithChildren,
  departmentsDepartmentsRoute: departmentsDepartmentsRouteWithChildren,
  guidesGuidesRoute: guidesGuidesRouteWithChildren,
  hotelsHotelsRoute: hotelsHotelsRouteWithChildren,
  operationsOperationsRoute: operationsOperationsRoute,
  providersProvidersRoute: providersProvidersRouteWithChildren,
  regionsRegionsRoute: regionsRegionsRouteWithChildren,
  servicesServicesRoute: servicesServicesRouteWithChildren,
  toursToursRoute: toursToursRouteWithChildren,
  workersWorkersRoute: workersWorkersRouteWithChildren,
  hotelRoomsHotelRoomsIdRoute: hotelRoomsHotelRoomsIdRouteWithChildren,
  reservationsReservationsNewRoute: reservationsReservationsNewRoute,
  serviceProvidersServiceProvidersIdRoute:
    serviceProvidersServiceProvidersIdRouteWithChildren,
  tourAgenciesTourAgenciesIdRoute: tourAgenciesTourAgenciesIdRouteWithChildren,
  tourDaysTourDaysIdRoute: tourDaysTourDaysIdRoute,
  reservationsReservationsIndexRoute: reservationsReservationsIndexRoute,
  reservationsReservationsIdEditRoute: reservationsReservationsIdEditRoute,
  reservationsReservationsIdFulfillmentsRoute:
    reservationsReservationsIdFulfillmentsRoute,
  reservationsReservationsIdIndexRoute: reservationsReservationsIdIndexRoute,
  reservationsReservationsCalendarIndexRoute:
    reservationsReservationsCalendarIndexRoute,
  reservationsReservationsCalendarIdEditRoute:
    reservationsReservationsCalendarIdEditRoute,
  reservationsReservationsCalendarIdFulfillmentsRoute:
    reservationsReservationsCalendarIdFulfillmentsRoute,
  reservationsReservationsCalendarIdIndexRoute:
    reservationsReservationsCalendarIdIndexRoute,
  reservationsReservationsCalendarNewIndexRoute:
    reservationsReservationsCalendarNewIndexRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/(agencies)/agencies",
        "/(departments)/departments",
        "/(guides)/guides",
        "/(hotels)/hotels",
        "/(operations)/operations",
        "/(providers)/providers",
        "/(regions)/regions",
        "/(services)/services",
        "/(tours)/tours",
        "/(workers)/workers",
        "/(hotel-rooms)/hotel-rooms/$id",
        "/(reservations)/reservations/new",
        "/(service-providers)/service-providers/$id",
        "/(tour-agencies)/tour-agencies/$id",
        "/(tour-days)/tour-days/$id",
        "/(reservations)/reservations/",
        "/(reservations)/reservations/$id/edit",
        "/(reservations)/reservations/$id/fulfillments",
        "/(reservations)/reservations/$id/",
        "/(reservations)/reservations/calendar/",
        "/(reservations)/reservations/calendar/$id/edit",
        "/(reservations)/reservations/calendar/$id/fulfillments",
        "/(reservations)/reservations/calendar/$id/",
        "/(reservations)/reservations/calendar/new/"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/(agencies)/agencies": {
      "filePath": "(agencies)/agencies.tsx",
      "children": [
        "/(agencies)/agencies/_sheet"
      ]
    },
    "/(departments)/departments": {
      "filePath": "(departments)/departments.tsx",
      "children": [
        "/(departments)/departments/_sheet"
      ]
    },
    "/(guides)/guides": {
      "filePath": "(guides)/guides.tsx",
      "children": [
        "/(guides)/guides/_sheet"
      ]
    },
    "/(hotels)/hotels": {
      "filePath": "(hotels)/hotels.tsx",
      "children": [
        "/(hotels)/hotels/_sheet"
      ]
    },
    "/(operations)/operations": {
      "filePath": "(operations)/operations.tsx"
    },
    "/(providers)/providers": {
      "filePath": "(providers)/providers.tsx",
      "children": [
        "/(providers)/providers/_sheet"
      ]
    },
    "/(regions)/regions": {
      "filePath": "(regions)/regions.tsx",
      "children": [
        "/(regions)/regions/_sheet"
      ]
    },
    "/(services)/services": {
      "filePath": "(services)/services.tsx",
      "children": [
        "/(services)/services/_sheet"
      ]
    },
    "/(tours)/tours": {
      "filePath": "(tours)/tours.tsx",
      "children": [
        "/(tours)/tours/_sheet"
      ]
    },
    "/(workers)/workers": {
      "filePath": "(workers)/workers.tsx",
      "children": [
        "/(workers)/workers/_sheet"
      ]
    },
    "/(agencies)/agencies/_sheet": {
      "filePath": "(agencies)/agencies/_sheet.tsx",
      "parent": "/(agencies)/agencies",
      "children": [
        "/(agencies)/agencies/_sheet/new",
        "/(agencies)/agencies/_sheet/$id/edit",
        "/(agencies)/agencies/_sheet/$id/"
      ]
    },
    "/(departments)/departments/_sheet": {
      "filePath": "(departments)/departments/_sheet.tsx",
      "parent": "/(departments)/departments",
      "children": [
        "/(departments)/departments/_sheet/new",
        "/(departments)/departments/_sheet/$id/edit",
        "/(departments)/departments/_sheet/$id/"
      ]
    },
    "/(guides)/guides/_sheet": {
      "filePath": "(guides)/guides/_sheet.tsx",
      "parent": "/(guides)/guides",
      "children": [
        "/(guides)/guides/_sheet/new",
        "/(guides)/guides/_sheet/$id/edit",
        "/(guides)/guides/_sheet/$id/"
      ]
    },
    "/(hotel-rooms)/hotel-rooms/$id": {
      "filePath": "(hotel-rooms)/hotel-rooms.$id.tsx",
      "children": [
        "/(hotel-rooms)/hotel-rooms/$id/_sheet"
      ]
    },
    "/(hotels)/hotels/_sheet": {
      "filePath": "(hotels)/hotels/_sheet.tsx",
      "parent": "/(hotels)/hotels",
      "children": [
        "/(hotels)/hotels/_sheet/new",
        "/(hotels)/hotels/_sheet/$id/edit",
        "/(hotels)/hotels/_sheet/$id/"
      ]
    },
    "/(providers)/providers/_sheet": {
      "filePath": "(providers)/providers/_sheet.tsx",
      "parent": "/(providers)/providers",
      "children": [
        "/(providers)/providers/_sheet/new",
        "/(providers)/providers/_sheet/$id/edit",
        "/(providers)/providers/_sheet/$id/"
      ]
    },
    "/(regions)/regions/_sheet": {
      "filePath": "(regions)/regions/_sheet.tsx",
      "parent": "/(regions)/regions",
      "children": [
        "/(regions)/regions/_sheet/new",
        "/(regions)/regions/_sheet/$id/edit",
        "/(regions)/regions/_sheet/$id/"
      ]
    },
    "/(reservations)/reservations/new": {
      "filePath": "(reservations)/reservations/new.tsx"
    },
    "/(service-providers)/service-providers/$id": {
      "filePath": "(service-providers)/service-providers.$id.tsx",
      "children": [
        "/(service-providers)/service-providers/$id/_sheet"
      ]
    },
    "/(services)/services/_sheet": {
      "filePath": "(services)/services/_sheet.tsx",
      "parent": "/(services)/services",
      "children": [
        "/(services)/services/_sheet/new",
        "/(services)/services/_sheet/$id/edit",
        "/(services)/services/_sheet/$id/"
      ]
    },
    "/(tour-agencies)/tour-agencies/$id": {
      "filePath": "(tour-agencies)/tour-agencies.$id.tsx",
      "children": [
        "/(tour-agencies)/tour-agencies/$id/_sheet"
      ]
    },
    "/(tour-days)/tour-days/$id": {
      "filePath": "(tour-days)/tour-days.$id.tsx"
    },
    "/(tours)/tours/_sheet": {
      "filePath": "(tours)/tours/_sheet.tsx",
      "parent": "/(tours)/tours",
      "children": [
        "/(tours)/tours/_sheet/new",
        "/(tours)/tours/_sheet/$id/edit",
        "/(tours)/tours/_sheet/$id/"
      ]
    },
    "/(workers)/workers/_sheet": {
      "filePath": "(workers)/workers/_sheet.tsx",
      "parent": "/(workers)/workers",
      "children": [
        "/(workers)/workers/_sheet/new",
        "/(workers)/workers/_sheet/$id/edit",
        "/(workers)/workers/_sheet/$id/"
      ]
    },
    "/(reservations)/reservations/": {
      "filePath": "(reservations)/reservations.index.tsx"
    },
    "/(agencies)/agencies/_sheet/new": {
      "filePath": "(agencies)/agencies/_sheet.new.tsx",
      "parent": "/(agencies)/agencies/_sheet"
    },
    "/(departments)/departments/_sheet/new": {
      "filePath": "(departments)/departments/_sheet.new.tsx",
      "parent": "/(departments)/departments/_sheet"
    },
    "/(guides)/guides/_sheet/new": {
      "filePath": "(guides)/guides/_sheet.new.tsx",
      "parent": "/(guides)/guides/_sheet"
    },
    "/(hotel-rooms)/hotel-rooms/$id/_sheet": {
      "filePath": "(hotel-rooms)/hotel-rooms.$id/_sheet.tsx",
      "parent": "/(hotel-rooms)/hotel-rooms/$id",
      "children": [
        "/(hotel-rooms)/hotel-rooms/$id/_sheet/$rid",
        "/(hotel-rooms)/hotel-rooms/$id/_sheet/new"
      ]
    },
    "/(hotels)/hotels/_sheet/new": {
      "filePath": "(hotels)/hotels/_sheet.new.tsx",
      "parent": "/(hotels)/hotels/_sheet"
    },
    "/(providers)/providers/_sheet/new": {
      "filePath": "(providers)/providers/_sheet.new.tsx",
      "parent": "/(providers)/providers/_sheet"
    },
    "/(regions)/regions/_sheet/new": {
      "filePath": "(regions)/regions/_sheet.new.tsx",
      "parent": "/(regions)/regions/_sheet"
    },
    "/(reservations)/reservations/$id/edit": {
      "filePath": "(reservations)/reservations/$id.edit.tsx"
    },
    "/(reservations)/reservations/$id/fulfillments": {
      "filePath": "(reservations)/reservations/$id.fulfillments.tsx"
    },
    "/(service-providers)/service-providers/$id/_sheet": {
      "filePath": "(service-providers)/service-providers.$id/_sheet.tsx",
      "parent": "/(service-providers)/service-providers/$id",
      "children": [
        "/(service-providers)/service-providers/$id/_sheet/new",
        "/(service-providers)/service-providers/$id/_sheet/edit/$spId"
      ]
    },
    "/(services)/services/_sheet/new": {
      "filePath": "(services)/services/_sheet.new.tsx",
      "parent": "/(services)/services/_sheet"
    },
    "/(tour-agencies)/tour-agencies/$id/_sheet": {
      "filePath": "(tour-agencies)/tour-agencies.$id/_sheet.tsx",
      "parent": "/(tour-agencies)/tour-agencies/$id",
      "children": [
        "/(tour-agencies)/tour-agencies/$id/_sheet/new",
        "/(tour-agencies)/tour-agencies/$id/_sheet/edit/$taId"
      ]
    },
    "/(tours)/tours/_sheet/new": {
      "filePath": "(tours)/tours/_sheet.new.tsx",
      "parent": "/(tours)/tours/_sheet"
    },
    "/(workers)/workers/_sheet/new": {
      "filePath": "(workers)/workers/_sheet.new.tsx",
      "parent": "/(workers)/workers/_sheet"
    },
    "/(reservations)/reservations/$id/": {
      "filePath": "(reservations)/reservations/$id.index.tsx"
    },
    "/(reservations)/reservations/calendar/": {
      "filePath": "(reservations)/reservations/calendar/index.tsx"
    },
    "/(agencies)/agencies/_sheet/$id/edit": {
      "filePath": "(agencies)/agencies/_sheet.$id.edit.tsx",
      "parent": "/(agencies)/agencies/_sheet"
    },
    "/(departments)/departments/_sheet/$id/edit": {
      "filePath": "(departments)/departments/_sheet.$id.edit.tsx",
      "parent": "/(departments)/departments/_sheet"
    },
    "/(guides)/guides/_sheet/$id/edit": {
      "filePath": "(guides)/guides/_sheet.$id.edit.tsx",
      "parent": "/(guides)/guides/_sheet"
    },
    "/(hotel-rooms)/hotel-rooms/$id/_sheet/$rid": {
      "filePath": "(hotel-rooms)/hotel-rooms.$id/_sheet.$rid.tsx",
      "parent": "/(hotel-rooms)/hotel-rooms/$id/_sheet"
    },
    "/(hotel-rooms)/hotel-rooms/$id/_sheet/new": {
      "filePath": "(hotel-rooms)/hotel-rooms.$id/_sheet.new.tsx",
      "parent": "/(hotel-rooms)/hotel-rooms/$id/_sheet"
    },
    "/(hotels)/hotels/_sheet/$id/edit": {
      "filePath": "(hotels)/hotels/_sheet.$id.edit.tsx",
      "parent": "/(hotels)/hotels/_sheet"
    },
    "/(providers)/providers/_sheet/$id/edit": {
      "filePath": "(providers)/providers/_sheet.$id.edit.tsx",
      "parent": "/(providers)/providers/_sheet"
    },
    "/(regions)/regions/_sheet/$id/edit": {
      "filePath": "(regions)/regions/_sheet.$id.edit.tsx",
      "parent": "/(regions)/regions/_sheet"
    },
    "/(reservations)/reservations/calendar/$id/edit": {
      "filePath": "(reservations)/reservations/calendar/$id.edit.tsx"
    },
    "/(reservations)/reservations/calendar/$id/fulfillments": {
      "filePath": "(reservations)/reservations/calendar/$id.fulfillments.tsx"
    },
    "/(service-providers)/service-providers/$id/_sheet/new": {
      "filePath": "(service-providers)/service-providers.$id/_sheet.new.tsx",
      "parent": "/(service-providers)/service-providers/$id/_sheet"
    },
    "/(services)/services/_sheet/$id/edit": {
      "filePath": "(services)/services/_sheet.$id.edit.tsx",
      "parent": "/(services)/services/_sheet"
    },
    "/(tour-agencies)/tour-agencies/$id/_sheet/new": {
      "filePath": "(tour-agencies)/tour-agencies.$id/_sheet.new.tsx",
      "parent": "/(tour-agencies)/tour-agencies/$id/_sheet"
    },
    "/(tours)/tours/_sheet/$id/edit": {
      "filePath": "(tours)/tours/_sheet.$id.edit.tsx",
      "parent": "/(tours)/tours/_sheet"
    },
    "/(workers)/workers/_sheet/$id/edit": {
      "filePath": "(workers)/workers/_sheet.$id.edit.tsx",
      "parent": "/(workers)/workers/_sheet"
    },
    "/(agencies)/agencies/_sheet/$id/": {
      "filePath": "(agencies)/agencies/_sheet.$id.index.tsx",
      "parent": "/(agencies)/agencies/_sheet"
    },
    "/(departments)/departments/_sheet/$id/": {
      "filePath": "(departments)/departments/_sheet.$id.index.tsx",
      "parent": "/(departments)/departments/_sheet"
    },
    "/(guides)/guides/_sheet/$id/": {
      "filePath": "(guides)/guides/_sheet.$id.index.tsx",
      "parent": "/(guides)/guides/_sheet"
    },
    "/(hotels)/hotels/_sheet/$id/": {
      "filePath": "(hotels)/hotels/_sheet.$id.index.tsx",
      "parent": "/(hotels)/hotels/_sheet"
    },
    "/(providers)/providers/_sheet/$id/": {
      "filePath": "(providers)/providers/_sheet.$id.index.tsx",
      "parent": "/(providers)/providers/_sheet"
    },
    "/(regions)/regions/_sheet/$id/": {
      "filePath": "(regions)/regions/_sheet.$id.index.tsx",
      "parent": "/(regions)/regions/_sheet"
    },
    "/(reservations)/reservations/calendar/$id/": {
      "filePath": "(reservations)/reservations/calendar/$id.index.tsx"
    },
    "/(reservations)/reservations/calendar/new/": {
      "filePath": "(reservations)/reservations/calendar/new.index.tsx"
    },
    "/(services)/services/_sheet/$id/": {
      "filePath": "(services)/services/_sheet.$id.index.tsx",
      "parent": "/(services)/services/_sheet"
    },
    "/(tours)/tours/_sheet/$id/": {
      "filePath": "(tours)/tours/_sheet.$id.index.tsx",
      "parent": "/(tours)/tours/_sheet"
    },
    "/(workers)/workers/_sheet/$id/": {
      "filePath": "(workers)/workers/_sheet.$id.index.tsx",
      "parent": "/(workers)/workers/_sheet"
    },
    "/(service-providers)/service-providers/$id/_sheet/edit/$spId": {
      "filePath": "(service-providers)/service-providers.$id/_sheet.edit.$spId.tsx",
      "parent": "/(service-providers)/service-providers/$id/_sheet"
    },
    "/(tour-agencies)/tour-agencies/$id/_sheet/edit/$taId": {
      "filePath": "(tour-agencies)/tour-agencies.$id/_sheet.edit.$taId.tsx",
      "parent": "/(tour-agencies)/tour-agencies/$id/_sheet"
    }
  }
}
ROUTE_MANIFEST_END */
